<script setup>
import moment from "moment"
moment.locale('id');
</script>
<template>
    <section class="row">
        <div class="col-md-3 col-lg-2">
            <SidebarComponent />
        </div>
        <main
            role="main"
            class="col-md-8 col-lg-10 py-5"
            id="content"
            style="font-family: Inter, sans-serif"
        >
            <div class="container">
                <!-- Kontraktor -->
                <div class="p-4 rounded-4 background mb-4 shadow-sm">
                    <div class="container-fluid py-1 text-white">
                        <div class="row">
                            <div class="col-md-8">
                                <h2 class="fw-bold">Selamat Datang,</h2>
                                <h4 class="fw-bold" v-if="userData.role === 'kontraktor'">
                                    {{ kontraktor.namaKontraktor }}
                                </h4>
                                <h4 class="fw-bold" v-else>{{ userData.name }}</h4>
                                <div
                                    class="d-flex bd-highlight mb-3"
                                    v-if="userData.role === 'kontraktor'"
                                >
                                    <div class="bd-highlight me-3">
                                        <small
                                            >Klasifikasi :
                                            <span>{{ kontraktor.jenis }}</span></small
                                        >
                                    </div>
                                    <div class="bd-highlight me-3">
                                        <small>|</small>
                                    </div>
                                    <div class="bd-highlight me-3">
                                        <small>
                                            <font-awesome-icon icon="location-dot" class="me-2" />
                                            {{
                                                kontraktor.provinsi == "Kalimantan Selatan"
                                                    ? "Lokal"
                                                    : "Non Lokal"
                                            }}
                                        </small>
                                    </div>
                                    <div class="bd-highlight me-3">
                                        <small>|</small>
                                    </div>
                                    <div class="bd-highlight me-3">
                                        Nilai Predikat :
                                        <span
                                            v-if="kontraktor.predikat == 'HIJAU'"
                                            style="color: #42b983"
                                        >
                                            <font-awesome-icon icon="fa-solid fa-square" style="" />
                                            {{
                                                kontraktor.nilaiPredikat != null
                                                    ? kontraktor.nilaiPredikat
                                                    : "-"
                                            }}
                                        </span>
                                        <span
                                            v-else-if="kontraktor.predikat == 'EMAS'"
                                            style="color: #eaaa69"
                                        >
                                            <font-awesome-icon icon="fa-solid fa-square" style="" />
                                            {{
                                                kontraktor.nilaiPredikat != null
                                                    ? kontraktor.nilaiPredikat
                                                    : "-"
                                            }}
                                        </span>
                                        <span
                                            v-else-if="kontraktor.predikat == 'BIRU'"
                                            style="color: #6a91d7"
                                        >
                                            <font-awesome-icon icon="fa-solid fa-square" style="" />
                                            {{
                                                kontraktor.nilaiPredikat != null
                                                    ? kontraktor.nilaiPredikat
                                                    : "-"
                                            }}
                                        </span>
                                        <span
                                            v-else-if="kontraktor.predikat == 'HITAM'"
                                            style="color: #171716"
                                        >
                                            <font-awesome-icon icon="fa-solid fa-square" style="" />
                                            {{
                                                kontraktor.nilaiPredikat != null
                                                    ? kontraktor.nilaiPredikat
                                                    : "-"
                                            }}
                                        </span>
                                        <span
                                            v-else-if="kontraktor.predikat == 'MERAH'"
                                            class="text-danger"
                                        >
                                            <font-awesome-icon icon="fa-solid fa-square" style="" />
                                            {{
                                                kontraktor.nilaiPredikat != null
                                                    ? kontraktor.nilaiPredikat
                                                    : "-"
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="col-md-4" v-if="userData.role !== 'kontraktor'">
                                <div class="card p-3 border-0 shadow-sm">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">
                                            <p class="text-secondary fw-bolder mb-1">Total CoC</p>
                                            &lt;!&ndash; <h8 class="text-black fw-bolder">Coming Soon</h8> &ndash;&gt;
                                            &lt;!&ndash;                      <div class="mt-3 d-inline-flex align-items-center gap-3">
                        <div class="border border-0 border-black p-1 rounded-1"
                             style="background: #0C8953; width: 15px"></div>
                        <p class="text-" style="font-size: 10px; margin: 0;">62% Pengesahan PJO Baru</p>
                      </div>
                      <div class="mt-3 d-inline-flex align-items-center gap-3">
                        <div class="border border-0 border-black p-1 rounded-1"
                             style="background: rgba(87, 235, 161, 1); width: 15px"></div>
                        <p class="text-" style="font-size: 10px; margin: 0;">13% Evaluasi</p>
                      </div>&ndash;&gt;
                                            <table class="table table-striped">
                                                <thead>
                                                    <tr class="fs-8 table-warning">
                                                        <th class="p-1" style="width:75%">Total Pengajuan</th>
                                                        <td class="p-1 text-end fw-bold" style="width:25%">{{dataDashboardSIO.totalPengajuan}}</td>
                                                    </tr> 
                                                    <tr class="fs-9">
                                                        <th class="p-1">Persyaratan Administratif</th>
                                                        <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalPersyaratanAdministratif}}</td>
                                                    </tr> 
                                                </thead>
                                                <tbody>
                                                    <tr class="fs-9">
                                                        <th class="p-1">Pembuatan Jadwal Presentasi</th>
                                                        <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalPembuatanJadwal}}</td>
                                                    </tr> 
                                                    <tr class="fs-9">
                                                        <th class="p-1">Presentasi Calon PJO</th>
                                                        <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalPresentasi}}</td>
                                                    </tr> 
                                                    <tr class="fs-9">
                                                        <th class="p-1">Pemenuhan NC Calon PJO</th>
                                                        <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalPemenuhanNc}}</td>
                                                    </tr> 
                                                    <tr class="fs-9">
                                                        <th class="p-1">Surat Pengesahan PJO</th>
                                                        <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalSuratPengesahan}}</td>
                                                    </tr> 
                                                    <tr class="fs-9 table-success">
                                                        <th class="p-1">CoC Approved</th>
                                                        <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalSioApproved}}</td>
                                                    </tr> 
                                                </tbody>
                                            </table>
                                        </div>
                                        &lt;!&ndash;                    <div class="col-md-6" v-if="userData.role !=='kontraktor'">
                      <canvas id="ChartSio" width="80" height="80"></canvas>
                    </div>&ndash;&gt;
                                    </div>
                                </div>
                            </div>-->
                        </div>
                        <div class="row" v-if="userData.role === 'kontraktor'">
                            <div class="col-md-12">
                                <div class="card p-4 mt-2 border-0 shadow-sm">
                                    <div class="d-flex justify-content-between">
                                        <div
                                            class="d-flex me-3 w-auto align-items-center mt-0 text-center justify-content-center rounded-3"
                                            :style="{
                                                minWidth: '70px',
                                                minHeight: '70px',
                                                background: 'rgba(181, 26, 26, 1)',
                                            }"
                                        >
                                            <h1
                                                class="mt-0 mb-0 text-white fa-2x fw-medium fw-bolder"
                                            >
                                                {{ getInitials(kontraktor.namaPjo) }}
                                            </h1>
                                        </div>
                                        <div class="d-flex flex-row align-items-center">
                                            <div class="d-flex flex-column">
                                                <div>
                                                    <small
                                                        class="me-3"
                                                        style="font-family: Inter-Thin, sans-serif"
                                                        >Info PJO</small
                                                    >
                                                    <small
                                                        v-if="isExpIujp"
                                                        class="me-3 text-danger"
                                                        style="
                                                            font-family: Inter-SemiBold, sans-serif;
                                                        "
                                                        >° IUJP anda akan berakhir kurang dari 6
                                                        bulan ({{
                                                            moment(kontraktor.masaBerlaku).format(
                                                                "DD-MMM-YYYY"
                                                            )
                                                        }})</small
                                                    >
                                                </div>
                                                <a style="font-family: Inter-Bold, sans-serif">{{
                                                    kontraktor.namaPjo
                                                }}</a>
                                                <a>No Surat : {{kontraktor.noPengesahanPjo != null ? kontraktor.noPengesahanPjo : '-'}}</a>
                                            </div>
                                        </div>
                                        <div
                                            class="d-flex align-items-center justify-content-end p-2 bd-highlight ms-auto"
                                        >
                                            <a
                                                v-bind:href="link"
                                                class="fs-6 text-danger d-flex align-items-center"
                                                style="font-weight: 700"
                                            >
                                                <strong
                                                    class="me-3"
                                                    style="
                                                        color: rgba(181, 26, 26, 1);
                                                        font-weight: 700;
                                                    "
                                                    >Edit Profil</strong
                                                >
                                                <font-awesome-icon
                                                    icon="arrow-right-long"
                                                    class="align-self-center"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="userData.role === 'kontraktor'">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-8 mt-2">
                                <div class="card shadow-lg border-0 p-3">
                                    <div class="row">
                                        <div class="col-md-6 col-sm-6 py-2">
                                          <div class="card text-black mb-3 border-0" style="background-color: #fae3c5;">
                                            <div class="card-header border-0">Total Kontrak Aktif</div>
                                            <div class="card-body">
                                              <h1 class="card-title">{{ totalKontrakAktif }}</h1>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 py-2">
                                          <div class="card text-black mb-3 border-0" style="background-color: #9df3cc">
                                            <div class="card-header border-0">Total Kontrak Selesai</div>
                                            <div class="card-body">
                                              <h1 class="card-title">{{ totalKontrakSelesai }}</h1>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                    <hr class="bg-secondary w-100" />
                                    <p class="text-secondary">
                                        dari Total Kontrak {{ userData.kontraktorName }}:
                                        <strong class="fw-bolder text-black">
                                            {{ totalKontrak }}</strong
                                        >
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-4 mt-2 scrollable-container">
                                <div class="card border-0 shadow-sm p-3 scrollable-content">
                                    <div
                                        class="d-flex justify-content-between align-items-center text-center"
                                    >
                                        <div class="text-end me-3">
                                            <p class="text-secondary mb-0">Ruang Lingkup Kontrak </p>
                                        </div>
                                        <div class="text-end me-3">
                                          <a v-bind:href="linkContract" class="fs-6 text-danger mb-0" style="text-decoration: none;font-weight: 700">Lihat Detail </a>
                                        </div>
                                    </div>
                                    <div class="mt-2" v-if="ruangLingkupArr3.length > 0">
                                      <div class="table-responsive">
                                        <table class="table-borderless mb-0" style="font-family: 'Inter-Regular', serif">
                                          <tbody style="font-weight: 500; font-size: 14px; color: #28293d" class="p-3">
                                          <tr v-for="(item, index) in ruangLingkupArr3" :key="index">
                                            <td width="5%" style="font-size:24px;color: #a44545;font-weight: bolder">{{ index+1 }}</td>
                                            <td>
                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item }}
                                            </td>
                                          </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div class="mt-2" v-else>
                                      <p class="mb-1 text-center" style="font-family: 'Inter-Thin'; font-size: 0.9rem; letter-spacing: 0.1rem;font-weight: bold;">Belum Ada Data Kontrak</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row py-3" v-if="userData.role === 'kontraktor'">
                            <div class="col-md-4">
                                <div class="card p-3 mb-2 border-0 shadow-lg">
                                    <p class="text-secondary fw-bolder" style="font-size: 14px">
                                        Subkontraktor Inti dan Non-Inti
                                    </p>
                                    <div class="row">
                                        <div class="col-md-7 col-sm-12 p-2">
                                            <p class="text-secondary">Total Subkontraktor</p>
                                            <h2 class="text-black fw-bolder">
                                                {{ totalSubKontraktorIntiNon }}
                                            </h2>
                                            <div
                                                class="mt-2 d-inline-flex align-items-center gap-3 mt-3"
                                            >
                                                <div
                                                    class="border border-0 border-black p-1 rounded-1"
                                                    style="
                                                        background: rgba(181, 26, 26, 1);
                                                        width: 15px;
                                                    "
                                                ></div>
                                                <p class="text-" style="font-size: 10px; margin: 0">
                                                    {{ totalPersentasiSubKonInti }} % Inti
                                                </p>
                                            </div>
                                            <div>
                                                <div
                                                    class="mt- d-inline-flex align-items-center gap-3"
                                                >
                                                    <div
                                                        class="border border-0 border-black p-1 rounded-1"
                                                        style="
                                                            background: rgba(255, 128, 128, 1);
                                                            width: 15px;
                                                        "
                                                    ></div>
                                                    <p
                                                        class="text-"
                                                        style="font-size: 10px; margin: 0"
                                                    >
                                                        {{ totalPersentasiSubKonNonInti }} % Non
                                                        Inti
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5 align-items-center py-3">
                                            <canvas
                                                id="SubKontIntiNonInti"
                                                width="80"
                                                height="80"
                                                class=""
                                            ></canvas>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card p-3 mb-2 border-0 shadow-lg">
                                    <div class="row">
                                        <p class="text-secondary fw-bolder" style="font-size: 14px">
                                            Subkontraktor Lokal dan Non-Lokal
                                        </p>
                                        <div class="col-md-7 col-sm-12 p-2">
                                            <p class="text-secondary">Total Subkontraktor</p>
                                            <h2 class="text-black fw-bolder">
                                                {{ totalSubKontraktorLokalNon }}
                                            </h2>
                                            <div
                                                class="mt-2 d-inline-flex align-items-center gap-3 mt-3"
                                            >
                                                <div
                                                    class="border border-0 border-black p-1 rounded-1"
                                                    style="
                                                        background: rgba(255, 136, 0, 1);
                                                        width: 15px;
                                                    "
                                                ></div>
                                                <p class="text-" style="font-size: 10px; margin: 0">
                                                    {{ totalPersentasiSubKonLokal }} % Lokal
                                                </p>
                                            </div>
                                            <div>
                                                <div
                                                    class="mt- d-inline-flex align-items-center gap-3"
                                                >
                                                    <div
                                                        class="border border-0 border-black p-1 rounded-1"
                                                        style="
                                                            background: rgba(252, 204, 117, 1);
                                                            width: 15px;
                                                        "
                                                    ></div>
                                                    <p
                                                        class="text-"
                                                        style="font-size: 10px; margin: 0"
                                                    >
                                                        {{ totalPersentasiSubKonNonLokal }} %
                                                        Non-Lokal
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5 align-items-center py-3">
                                            <canvas
                                                id="SubKonLokalSubNonLokal"
                                                width="80"
                                                height="80"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card border-0 shadow-lg p-3">
                                  <div
                                        class="d-flex justify-content-between align-items-center text-center"
                                    >
                                    <p
                                        class="fw-bolder text-secondary mb-0"
                                        style="font-size: 14px"
                                    >
                                        Status CoC :
                                      <a v-if="dataSio != null">
                                        <a class="text-warning fw-bolder" style="text-decoration: none" v-if="dataSio.status == 0">Draft</a>
                                        <a class="text-info fw-bolder" style="text-decoration: none" v-else-if="dataSio.status == 1">On Review</a>
                                        <a class="text-danger fw-bolder" style="text-decoration: none" v-else-if="dataSio.status == 2">Document Complete</a>
                                        <a class="text-warning fw-bolder" style="text-decoration: none" v-else-if="dataSio.status == -3">Need Revision</a>
                                        <a class="text-danger fw-bolder" style="text-decoration: none" v-else-if="dataSio.status == -4">CoC Expired</a>
                                        <a class="text-success fw-bolder" style="text-decoration: none" v-else-if="dataSio.status == 3">CoC Already Publish</a>
                                        <a class="text-danger fw-bolder" style="text-decoration: none" v-else-if="dataSio.status == 5">Ready to Publish</a>
                                        <a class="text-danger fw-bolder" style="text-decoration: none" v-else-if="dataSio.status == 6">NC Revision</a>
                                        <a class="text-danger fw-bolder" style="text-decoration: none" v-else-if="dataSio.status == 7">Surat Pengesahan PJO Publish</a>
                                        <a class="text-danger fw-bolder" style="text-decoration: none" v-else-if="dataSio.status == 8">Update Data Kontraktor</a>
                                      </a>
                                    </p>
                                    <div class="text-end me-3">
                                      <a v-bind:href="linkSio" class="fs-6 text-danger mb-0" style="text-decoration: none;font-weight: 700">Lihat Detail </a>
                                    </div>
                                  </div>
                                    <div class="d-flex">
                                        <div class="text-start me-3">
                                            <p class="text-secondary mb-0" v-if="dataSio.status == 1" >Dokumen CoC dalam proses peninjauan oleh PT Borneo Indobara</p>
                                            <p class="text-secondary mb-0" v-else-if="dataSio.status == 2" >Hasil presentasi calon PJO sudah memadai</p>
                                            <p class="text-secondary mb-0" v-else-if="dataSio.status == -3" >Dokumen CoC diperlukan revisi</p>
                                            <p class="text-secondary mb-0" v-else-if="dataSio.status == -4" >Masa berlaku CoC telah berakhir</p>
                                            <p class="text-secondary mb-0" v-else-if="dataSio.status == 3" >Dokumen CoC sudah disetujui KTT, Perusahaan dapat melakukan pekerjaan</p>
                                            <p class="text-secondary mb-0" v-else-if="dataSio.status == 5" >Hasil presentasi calon PJO sudah memadai</p>
                                            <p class="text-secondary mb-0" v-else-if="dataSio.status == 6" >Pengajuan CoC terdapat NC</p>
                                            <p class="text-secondary mb-0" v-else-if="dataSio.status == 7" >Dokumen Surat Pengesahan PJO sudah disetujui KTT</p>
                                            <p class="text-secondary mb-0" v-else-if="dataSio.status == 8" >Penerbitan CoC ditangguhkan karena butuh update data kontraktor</p>
                                        </div>
                                    </div>

                                    <div class="progress w-100" style="width: 100px;">
                                      <div class="progress-bar bg-danger" role="progressbar" :style="{width: dataSio != null ? (dataSio.status == 0 ? '10%' : dataSio.status == 1 ? '20%' : dataSio.status == -3 ? '20%' : dataSio.status == 2 ? '30%' : dataSio.status == 5 ? '60%' : dataSio.status == 6 ? '60%' : dataSio.status == 3 ? '100%' : dataSio.status == 7 ? '70%' : dataSio.status == 8 ? '70%' : '0%') : '0%' }" aria-valuenow="50"
                                           aria-valuemin="0" aria-valuemax="100">
                                      </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center text-center mt-2" style="font-size: 10px; font-family: Inter, sans-serif">
                                      <div class="text-end me-3">
                                        <p class="fw-bolder text-secondary mb-0">Progress</p>
                                      </div>
                                      <div class="ms-3">
                                        <span class="">{{dataSio != null ? (dataSio.status == 0 ? '10%' : dataSio.status == 1 ? '20%' : dataSio.status == -3 ? '20%' : dataSio.status == 2 ? '30%' : dataSio.status == 5 ? '80%' : dataSio.status == 6 ? '50%' : dataSio.status == 3 ? '100%' : '0%') : '0%'}}</span>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Kontraktor -->

                <!-- Admin atau Isafe-->
                <div class="container" v-if="userData.role !== 'kontraktor'">
                  <div class="row">
                    <div class="col-md-12 mt-2">
                      <div class="card shadow-lg border-0 p-3">
                        <div class="row">
                          <div class="col-md-6 col-sm-6 py-2">
                            <!--                                  <p class="fw-bolder text-secondary">Total Kontrak Aktif</p>-->
                            <!--                                    <h1 class="fw-bolder mt-3">{{ totalKontrakInternalAktif }}</h1>-->
                            <div class="card text-black mb-3 border-0" style="background-color: #fae3c5;border: none">
                              <div class="card-header border-0">Total Kontrak Aktif</div>
                              <div class="card-body">
                                <h1 class="card-title">{{ totalKontrakInternalAktif }}</h1>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 col-sm-6 py-2">
                            <!--                                    <p class="fw-bolder text-secondary">Total Kontrak Selesai</p>
                                                                <h1 class="fw-bolder mt-3">
                                                                    {{ totalKontrakInternalSelesai }}
                                                                </h1>-->
                            <div class="card text-black mb-3 border-0" style="background-color: #9df3cc;border: none">
                              <div class="card-header border-0">Total Kontrak Selesai</div>
                              <div class="card-body">
                                <h1 class="card-title">{{ totalKontrakInternalSelesai }}</h1>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr class="bg-secondary w-100" />
                        <p class="text-secondary fs-5">
                          dari Total Kontrak:
                          <strong class="fw-bolder text-black">
                            {{ totalKontrakInternal }}</strong
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mt-2">
                      <div class="card shadow-lg border-0 p-1 bg-warning-subtle">
                        <strong class="fw-bolder p-1 fs-5">Total CoC Pengesahan PJO Baru</strong>
                        <div class="col-md-12 align-items-center" v-if="userData.role !== 'kontraktor'">
                          <div class="card p-1 border-0 shadow-sm">
                            <div class="row">
                              <div class="col-md-12 col-sm-12">
                                <table class="table table-borderless table-striped">
                                  <thead>
                                  <tr class="fs-8 table-warning">
                                    <th class="p-1" style="width:75%">Total Pengajuan</th>
                                    <td class="p-1 text-end fw-bold" style="width:25%">{{dataDashboardSIO.totalPengajuan}}</td>
                                  </tr>
                                  <tr class="fs-9">
                                    <th class="p-1">Persyaratan Administratif</th>
                                    <td class="p-1 text-end fw-bold">
                                      {{dataDashboardSIO.totalPersyaratanAdministratif}}
                                    </td>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr class="fs-9">
                                    <th class="p-1">Pembuatan Jadwal Presentasi</th>
                                    <td class="p-1 text-end fw-bold">
                                      {{dataDashboardSIO.totalPembuatanJadwal}}
                                    </td>
                                  </tr>
                                  <tr class="fs-9">
                                    <th class="p-1">Presentasi Calon PJO</th>
                                    <td class="p-1 text-end fw-bold">
                                      {{dataDashboardSIO.totalPresentasi}}
                                    </td>
                                  </tr>
                                  <tr class="fs-9">
                                    <th class="p-1">Pemenuhan NC Calon PJO</th>
                                    <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalPemenuhanNc}}</td>
                                  </tr>
                                  <tr class="fs-9">
                                    <th class="p-1">Proses Surat Pengesahan PJO</th>
                                    <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalProsesSuratPengesahan}}</td>
                                  </tr>
                                  <tr class="fs-9">
                                    <th class="p-1">Surat Pengesahan PJO</th>
                                    <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalSuratPengesahan}}</td>
                                  </tr>
                                  <tr class="fs-9 table-success">
                                    <th class="p-1">CoC Approved</th>
                                    <td class="p-1 text-end fw-bold">{{dataDashboardSIO.totalSioApproved}}</td>
                                  </tr>
                                  </tbody>
                                </table>
<!--                                <div class="modal fade rounded-top-5" id="kontraktorAdministratif" tabindex="-1" aria-labelledby="kontraktorAdministratif" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Persyaratan Administratif</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in dataDashboardSIO.kontraktorPersyaratanAdministratif" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal fade rounded-top-5" id="kontraktorPenjadwalan" tabindex="-1" aria-labelledby="kontraktorPenjadwalan" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Pembuatan Jadwal Presentasi</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in dataDashboardSIO.kontraktorPembuatanJadwal" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal fade rounded-top-5" id="kontraktorPresentasi" tabindex="-1" aria-labelledby="kontraktorPresentasi" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Presentasi Calon PJO</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in dataDashboardSIO.kontraktorPresentasi" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>-->
                              </div>
                              <!--                    <div class="col-md-6" v-if="userData.role !=='kontraktor'">
            <canvas id="ChartSio" width="80" height="80"></canvas>
          </div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                      <div class="col-md-6 mt-2">
                          <div class="card shadow-lg border-0 p-1 bg-success-subtle">
                            <strong class="fw-bolder p-1 fs-5">Total Pengajuan IMKP</strong>
                            <div class="col-md-12 align-items-center" v-if="userData.role !== 'kontraktor'">
                              <div class="card p-1 border-0 shadow-sm">
                                <div class="row">
                                  <div class="col-md-12 col-sm-12">
                                    <table class="table table-borderless table-striped">
                                      <thead>
                                      <tr class="fs-8 table-warning">
                                        <th class="p-1" style="width:75%">Total Pengajuan</th>
                                        <td class="p-1 text-end fw-bold" style="width:25%">{{dataDashboardImkp.totalImkp}}</td>
                                      </tr>
                                      <tr class="fs-9">
                                        <th class="p-1">Review Admin / OHS</th>
                                        <td class="p-1 text-end fw-bold">
                                          {{dataDashboardImkp.totalImkpUnderReview}}
                                        </td>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <tr class="fs-9">
                                        <th class="p-1">Membutuhkan Revisi</th>
                                        <td class="p-1 text-end fw-bold">
                                          {{dataDashboardImkp.totalNeedRevision}}
                                        </td>
                                      </tr>
                                      <tr class="fs-9">
                                        <th class="p-1">Dokumen sudah terverifikasi</th>
                                        <td class="p-1 text-end fw-bold">
                                          {{dataDashboardImkp.totalDocumentComplete}}
                                        </td>
                                      </tr>
                                      <tr class="fs-9">
                                        <th class="p-1">Proses Penerbitan IMKP</th>
                                        <td class="p-1 text-end fw-bold">{{dataDashboardImkp.totalProsesPenerbitanImkp}}</td>
                                      </tr>
                                      <tr class="fs-9">
                                        <th class="p-1">IMKP Published</th>
                                        <td class="p-1 text-end fw-bold">{{dataDashboardImkp.totalImkpPublished}}</td>
                                      </tr>
                                      <tr class="fs-9">
                                        <th class="p-1">Process BAST IMKP</th>
                                        <td class="p-1 text-end fw-bold">{{dataDashboardImkp.totalProccessBast}}</td>
                                      </tr>
                                      <tr class="fs-9">
                                        <th class="p-1">BAST IMKP Done</th>
                                        <td class="p-1 text-end fw-bold">{{dataDashboardImkp.totalBastDone}}</td>
                                      </tr>
                                      </tbody>
                                    </table>
                                    <div class="modal fade rounded-top-5" id="kontraktorAdministratif" tabindex="-1" aria-labelledby="kontraktorAdministratif" aria-hidden="true">
                                      <div class="modal-dialog-centered rounded-top-5">
                                        <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                             style="min-height: 156px; min-width: 350px;">
                                          <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                               style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                            <div class="d-flex justify-content-end w-100 p-2">
                                              <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                                <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                              </button>
                                            </div>
                                            <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                              <h4 class="fw-bold">Persyaratan Administratif</h4>
                                            </div>
                                          </div>
                                          <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                            <div class="p-3">
                                              <div class="table-responsive">
                                                <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                                  <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                                  <tr class="table-danger">
                                                    <th class="p-2 text-nowrap" style="width: 10%">
                                                      No.
                                                    </th>
                                                    <th class="p-2 text-nowrap" style="width: 90%">
                                                      Nama Kontraktor
                                                    </th>
                                                  </tr>
                                                  </thead>
                                                  <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                                  <tr v-for="(item, index) in dataDashboardSIO.kontraktorPersyaratanAdministratif" :key="index">
                                                    <td>{{ index+1 }}</td>
                                                    <td>{{ item.toString() }}</td>
                                                  </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="modal fade rounded-top-5" id="kontraktorPenjadwalan" tabindex="-1" aria-labelledby="kontraktorPenjadwalan" aria-hidden="true">
                                      <div class="modal-dialog-centered rounded-top-5">
                                        <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                             style="min-height: 156px; min-width: 350px;">
                                          <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                               style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                            <div class="d-flex justify-content-end w-100 p-2">
                                              <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                                <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                              </button>
                                            </div>
                                            <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                              <h4 class="fw-bold">Pembuatan Jadwal Presentasi</h4>
                                            </div>
                                          </div>
                                          <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                            <div class="p-3">
                                              <div class="table-responsive">
                                                <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                                  <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                                  <tr class="table-danger">
                                                    <th class="p-2 text-nowrap" style="width: 10%">
                                                      No.
                                                    </th>
                                                    <th class="p-2 text-nowrap" style="width: 90%">
                                                      Nama Kontraktor
                                                    </th>
                                                  </tr>
                                                  </thead>
                                                  <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                                  <tr v-for="(item, index) in dataDashboardSIO.kontraktorPembuatanJadwal" :key="index">
                                                    <td>{{ index+1 }}</td>
                                                    <td>{{ item.toString() }}</td>
                                                  </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="modal fade rounded-top-5" id="kontraktorPresentasi" tabindex="-1" aria-labelledby="kontraktorPresentasi" aria-hidden="true">
                                      <div class="modal-dialog-centered rounded-top-5">
                                        <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                             style="min-height: 156px; min-width: 350px;">
                                          <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                               style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                            <div class="d-flex justify-content-end w-100 p-2">
                                              <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                                <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                              </button>
                                            </div>
                                            <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                              <h4 class="fw-bold">Presentasi Calon PJO</h4>
                                            </div>
                                          </div>
                                          <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                            <div class="p-3">
                                              <div class="table-responsive">
                                                <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                                  <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                                  <tr class="table-danger">
                                                    <th class="p-2 text-nowrap" style="width: 10%">
                                                      No.
                                                    </th>
                                                    <th class="p-2 text-nowrap" style="width: 90%">
                                                      Nama Kontraktor
                                                    </th>
                                                  </tr>
                                                  </thead>
                                                  <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                                  <tr v-for="(item, index) in dataDashboardSIO.kontraktorPresentasi" :key="index">
                                                    <td>{{ index+1 }}</td>
                                                    <td>{{ item.toString() }}</td>
                                                  </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!--                    <div class="col-md-6" v-if="userData.role !=='kontraktor'">
                <canvas id="ChartSio" width="80" height="80"></canvas>
              </div>-->
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="container" v-if="userData.role !== 'kontraktor'">
                  <div class="card shadow-lg rounded-4 border-0 mt-lg-3">
                    <div>
                      <h3 class="px-3 pt-4 text-black fw-bolder">Total Main Kontraktor : {{ totalMainKontraktor }}</h3>
                      <p class=" px-3 fst-italic text-secondary-emphasis" style="font-size: 12px">* Kontraktor yang berkontrak langsung dengan BIB</p>
                    </div>
                    <div class="row p-3">
                      <div class="col-md-3">
                        <div class="card p-3 mb-2 border-0 shadow-lg">
                          <div class="row">
                            <p class="text-secondary mb-1" style="font-size: 11px;color: #555770;">
                              Main Kontraktor
                            </p>
                            <p class="text-secondary fw-bolder" style="font-size: 14px">
                              Berdasarkan Tingkat Resiko
                            </p>
                            <div class="col-md-5 col-sm-12 p-0 mt-4">
<!--                              <p class="text-secondary">Total Kontraktor</p>
                              <h2 class="text-black fw-bolder">
                                {{ totalKontraktorbyTingkatResiko }}
                              </h2>-->
                              <div class="d-inline-flex align-items-center gap-1 mt-1">
                                <div
                                    class="border border-0 border-black p-1 rounded-1"
                                    style="background: rgba(181, 26, 26, 1); width: 40px"
                                ><a v-if="mainNamaKontraktorKritis != null" data-bs-toggle="modal" data-bs-target="#mainKontraktorKritis" style="font-size: 10px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                <div class="modal fade rounded-top-5" id="mainKontraktorKritis" tabindex="-1" aria-labelledby="mainKontraktorKritis" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Main Kontraktor Tingkat Resiko Kritis</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in mainNamaKontraktorKritis" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                  {{ (kontraktorKritis/totalKontraktorbyTingkatResiko*100).toFixed(0) }}% Kritis
                                </p>
                              </div>
                              <div class="mt-1 d-inline-flex align-items-center gap-1">
                                <div
                                    class="border border-0 border-black p-1 rounded-1"
                                    style="
                                                    background: rgba(255, 92, 92, 1);
                                                    width: 40px;
                                                "
                                ><a v-if="mainNamaKontraktorTinggi != null" data-bs-toggle="modal" data-bs-target="#mainKontraktorTinggi" style="font-size: 10px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                <div class="modal fade rounded-top-5" id="mainKontraktorTinggi" tabindex="-1" aria-labelledby="mainKontraktorTinggi" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Main Kontraktor Tingkat Resiko Tinggi</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in mainNamaKontraktorTinggi" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                  {{ (kontraktorTinggi/totalKontraktorbyTingkatResiko*100).toFixed(0) }}% Tinggi
                                </p>
                              </div>
                              <div class="mt-1 d-inline-flex align-items-center gap-1">
                                <div
                                    class="border border-0 border-black p-1 rounded-1"
                                    style="background: rgba(87, 235, 161, 1); width: 40px"
                                ><a v-if="mainNamaKontraktorSedang != null" data-bs-toggle="modal" data-bs-target="#mainKontraktorSedang" style="font-size: 10px;color: black; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                <div class="modal fade rounded-top-5" id="mainKontraktorSedang" tabindex="-1" aria-labelledby="mainKontraktorSedang" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Main Kontraktor Tingkat Resiko Sedang</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in mainNamaKontraktorSedang" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                  {{ (kontraktorSedang/totalKontraktorbyTingkatResiko*100).toFixed(0) }}% Sedang
                                </p>
                              </div>
                              <div class="mt-1 d-inline-flex align-items-center gap-1">
                                <div
                                    class="border border-0 border-black p-1 rounded-1"
                                    style="
                                                    background: rgba(252, 204, 117, 1);
                                                    width: 40px;
                                                "
                                ><a v-if="mainNamaKontraktorRendah != null" data-bs-toggle="modal" data-bs-target="#mainKontraktorRendah" style="font-size: 10px;color: black; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                <div class="modal fade rounded-top-5" id="mainKontraktorRendah" tabindex="-1" aria-labelledby="mainKontraktorRendah" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Main Kontraktor Tingkat Resiko Rendah</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in mainNamaKontraktorRendah" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                  {{ (kontraktorRendah/totalKontraktorbyTingkatResiko*100).toFixed(0) }}% Rendah
                                </p>
                              </div>
                            </div>
                            <div
                                class="col-md-7 align-items-center py-3"
                                v-if="userData.role !== 'kontraktor'"
                            >
                              <canvas
                                  id="kontraktorTingkatResiko"
                                  width="10"
                                  height="10"
                                  class=""
                              ></canvas>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                      <div class="card p-3 mb-2 border-0 shadow-lg">
                        <div class="row">
                          <p class="text-secondary mb-1" style="font-size: 11px;color: #555770;">
                            Main Kontraktor
                          </p>
                          <p class="text-secondary fw-bolder" style="font-size: 14px">
                            Inti & Non Inti
                          </p>
                          <div class="col-md-5 col-sm-12 p-0 mt-5">
<!--                            <p class="text-secondary">Total Kontraktor</p>
                            <h2 class="text-black fw-bolder">
                              {{ totalMainIntiNonInti }}
                            </h2>-->
                            <div class="d-inline-flex align-items-center gap-1 mt-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="background: rgba(181, 26, 26, 1); width: 40px"
                              ><a data-bs-toggle="modal" data-bs-target="#mainKontraktorInti" style="font-size: 10px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="mainKontraktorInti" tabindex="-1" aria-labelledby="mainKontraktorInti" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Main Kontraktor Inti</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaKontraktorInti" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                {{ (mainKontraktorInti/totalMainIntiNonInti*100).toFixed(0) }}% Inti
                              </p>
                            </div>
                            <div class="mt-1 d-inline-flex align-items-center gap-1">
                                <div
                                    class="border border-0 border-black p-1 rounded-1"
                                    style="
                                                      background: rgba(255, 128, 128, 1);
                                                      width: 40px;
                                                  "
                                ><a data-bs-toggle="modal" data-bs-target="#mainKontraktorNonInti" style="font-size: 10px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                <div class="modal fade rounded-top-5" id="mainKontraktorNonInti" tabindex="-1" aria-labelledby="mainKontraktorNonInti" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Main Kontraktor Non Inti</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in mainNamaKontraktorNonInti" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                  {{ (mainKontraktorNonInti/totalMainIntiNonInti*100).toFixed(0) }}% Non Inti
                                </p>
                              </div>
                          </div>
                          <div
                              class="col-md-7 align-items-center py-3"
                              v-if="userData.role !== 'kontraktor'"
                          >
                            <canvas
                                id="mainKontraktorIntiNonInti"
                                width="10"
                                height="10"
                                class=""
                            ></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                      <div class="col-md-3">
                        <div class="card p-3 mb-2 border-0 shadow-lg">
                        <div class="row">
                          <p class="text-secondary mb-1" style="font-size: 11px;color: #555770;">
                            Main Kontraktor
                          </p>
                          <p class="text-secondary fw-bolder" style="font-size: 14px">
                            Lokal & Non Lokal
                          </p>
<!--                          <p class="fst-italic text-secondary-emphasis" style="font-size: 9px">
                            * Kontraktor yang berkontrak langsung dengan BIB
                          </p>-->
                          <div class="col-md-5 col-sm-12 p-0 mt-5">
<!--                            <p class="text-secondary">Total Kontraktor</p>-->
<!--                            <h2 class="text-black fw-bolder">-->
<!--                              {{ totalKontraktorbyTingkatResiko }}-->
<!--                            </h2>-->
                            <div class="d-inline-flex align-items-center gap-1 mt-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="background: rgba(252, 204, 117, 1); width: 40px;"
                              ><a v-if="mainNamaKontraktorLokal.length >0" data-bs-toggle="modal" data-bs-target="#mainKontraktorLokal" style="font-size: 10px;color: black; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="mainKontraktorLokal" tabindex="-1" aria-labelledby="mainKontraktorLokal" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Main Kontraktor Lokal</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaKontraktorLokal" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                {{ (mainKontraktorLokal/totalMainLokalNonLokal*100).toFixed(0) }}% Lokal
                              </p>
                            </div>
                            <div class="mt-1 d-inline-flex align-items-center gap-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="
                                                    background: rgba(255, 136, 0, 1);
                                                    width: 40px;
                                                "
                              ><a v-if="mainNamaKontraktorNonLokal.length > 0" data-bs-toggle="modal" data-bs-target="#mainKontraktorNonLokal" style="font-size: 10px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="mainKontraktorNonLokal" tabindex="-1" aria-labelledby="mainKontraktorNonLokal" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Main Kontraktor Non Lokal</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaKontraktorNonLokal" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                {{(mainKontraktorNonLokal/totalMainLokalNonLokal*100).toFixed(0)}}% Non Lokal
                              </p>
                            </div>
                          </div>
                          <div
                              class="col-md-7 align-items-center py-3"
                              v-if="userData.role !== 'kontraktor'"
                          >
                            <canvas
                                id="mainKontraktorLokalNonLokal"
                                width="10"
                                height="10"
                                class=""
                            ></canvas>
                          </div>
                        </div>
                      </div>
                      </div>
                      <div class="col-md-3">
                        <div class="card p-3 mb-2 border-0 shadow-lg">
                          <div class="row">
                            <p class="text-secondary mb-1" style="font-size: 11px;color: #555770;">
                              Main Kontraktor
                            </p>
                            <p class="text-secondary fw-bolder" style="font-size: 14px">
                              Berdasarkan Kualifikasi Usaha
                            </p>
                            <div class="col-md-5 col-sm-12 p-0 mt-4">
                              <div class="d-inline-flex align-items-center gap-1 mt-1">
                                <div
                                    class="border border-0 border-black p-1 rounded-1"
                                    style="background: rgb(222,156,159); width: 40px;"
                                ><a v-if="mainNamaKontraktorUsahaBesar != null" data-bs-toggle="modal" data-bs-target="#mainNamaKontraktorUsahaBesar" style="font-size: 10px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                <div class="modal fade rounded-top-5" id="mainNamaKontraktorUsahaBesar" tabindex="-1" aria-labelledby="mainNamaKontraktorUsahaBesar" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Main Kontraktor Besar</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in mainNamaKontraktorUsahaBesar" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                  {{ (mainKontraktorBesar/(totalMainKualifikasiUsaha > 0 ? totalMainKualifikasiUsaha : 1)*100).toFixed(0) }}% Besar
                                </p>
                              </div>
                              <div class="mt-1 d-inline-flex align-items-center gap-1">
                                <div
                                    class="border border-0 border-black p-1 rounded-1"
                                    style="
                                                    background: rgb(246,133,133);
                                                    width: 40px;
                                                "
                                ><a v-if="mainNamaKontraktorUsahaSedang != null" data-bs-toggle="modal" data-bs-target="#mainNamaKontraktorUsahaSedang" style="font-size: 10px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                <div class="modal fade rounded-top-5" id="mainNamaKontraktorUsahaSedang" tabindex="-1" aria-labelledby="mainNamaKontraktorUsahaSedang" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Main Kontraktor Sedang</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in mainNamaKontraktorUsahaSedang" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                  {{ (mainKontraktorSedang/(totalMainKualifikasiUsaha > 0 ? totalMainKualifikasiUsaha : 1)*100).toFixed(0) }}% Sedang
                                </p>
                              </div>
                              <div class="mt-1 d-inline-flex align-items-center gap-1">
                                <div
                                    class="border border-0 border-black p-1 rounded-1"
                                    style="
                                                    background: rgb(243,86,86);
                                                    width: 40px;
                                                "
                                ><a v-if="mainNamaKontraktorUsahaKecil != null" data-bs-toggle="modal" data-bs-target="#mainNamaKontraktorUsahaKecil" style="font-size: 10px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                <div class="modal fade rounded-top-5" id="mainNamaKontraktorUsahaKecil" tabindex="-1" aria-labelledby="mainNamaKontraktorUsahaKecil" aria-hidden="true">
                                  <div class="modal-dialog-centered rounded-top-5">
                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                         style="min-height: 156px; min-width: 350px;">
                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                        <div class="d-flex justify-content-end w-100 p-2">
                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                          </button>
                                        </div>
                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                          <h4 class="fw-bold">Main Kontraktor Kecil</h4>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                        <div class="p-3">
                                          <div class="table-responsive">
                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                              <tr class="table-danger">
                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                  No.
                                                </th>
                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                  Nama Kontraktor
                                                </th>
                                              </tr>
                                              </thead>
                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                              <tr v-for="(item, index) in mainNamaKontraktorUsahaKecil" :key="index">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.toString() }}</td>
                                              </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p class="text-black fw-bolder" style="font-size: 10px; margin: 0">
                                  {{ (mainKontraktorKecil/(totalMainKualifikasiUsaha > 0 ? totalMainKualifikasiUsaha : 1)*100).toFixed(0) }}% Kecil
                                </p>
                              </div>
                            </div>
                            <div
                                class="col-md-7 align-items-center py-3"
                                v-if="userData.role !== 'kontraktor'"
                            >
                              <canvas
                                  id="mainKontraktorKualifikasiUsaha"
                                  width="10"
                                  height="10"
                                  class=""
                              ></canvas>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container" v-if="userData.role !== 'kontraktor'">
                <div class="card shadow-lg rounded-4 border-0 mt-lg-3">
                  <div>
                    <h3 class="px-3 pt-4 text-black fw-bolder">Total Sub Kontraktor : {{ totalSubKontraktor }}</h3>
                    <p class=" px-3 fst-italic text-secondary-emphasis" style="font-size: 12px">* Kontraktor yang berkontrak langsung dengan main Kontraktor</p>
                  </div>
                  <div class="row p-3">
                    <div class="col-md-4">
                      <div class="card p-3 mb-2 border-0 shadow-lg">
                        <div class="row">
                          <p class="text-secondary mb-1" style="font-size: 11px;color: #555770;">
                            Sub Kontraktor
                          </p>
                          <p class="text-secondary fw-bolder" style="font-size: 14px">
                            Inti & Non Inti
                          </p>
                          <div class="col-md-5 col-sm-12 p-1 mt-5">
                            <div class="d-inline-flex align-items-center gap-1 mt-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="background: rgba(181, 26, 26, 1); width: 50px"
                              ><a data-bs-toggle="modal" data-bs-target="#subKontraktorInti" style="font-size: 12px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="subKontraktorInti" tabindex="-1" aria-labelledby="subKontraktorInti" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Sub Kontraktor Inti</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaSubKontraktorInti" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                {{ (totalSubKontraktorInti/totalSubKontraktor*100).toFixed(0) }}% Inti
                              </p>
                            </div>
                            <div class="mt-1 d-inline-flex align-items-center gap-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="
                                                      background: rgba(255, 128, 128, 1);
                                                      width: 50px;
                                                  "
                              ><a data-bs-toggle="modal" data-bs-target="#subKontraktorNonInti" style="font-size: 12px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="subKontraktorNonInti" tabindex="-1" aria-labelledby="subKontraktorNonInti" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Sub Kontraktor Non Inti</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaSubKontraktorNonInti" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                {{ (totalSubKontraktorNonInti/totalSubKontraktor*100).toFixed(0) }}% Non Inti
                              </p>
                            </div>
                          </div>
                          <div
                              class="col-md-7 align-items-center py-3"
                              v-if="userData.role !== 'kontraktor'"
                          >
                            <canvas
                                id="subKontraktorIntiNonInti"
                                width="10"
                                height="10"
                                class=""
                            ></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card p-3 mb-2 border-0 shadow-lg">
                        <div class="row">
                          <p class="text-secondary mb-1" style="font-size: 11px;color: #555770;">
                            Sub Kontraktor
                          </p>
                          <p class="text-secondary fw-bolder" style="font-size: 14px">
                            Lokal & Non Lokal
                          </p>
                          <div class="col-md-5 col-sm-12 p-1 mt-5">
                            <div class="d-inline-flex align-items-center gap-1 mt-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="background: rgba(252, 204, 117, 1); width: 50px;"
                              ><a v-if="mainNamaSubKontraktorLokal.length >0" data-bs-toggle="modal" data-bs-target="#subKontraktorLokal" style="font-size: 12px;color: black; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="subKontraktorLokal" tabindex="-1" aria-labelledby="subKontraktorLokal" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Sub Kontraktor Lokal</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaSubKontraktorLokal" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                {{ (totalSubKontraktorLokals/totalSubKontraktor*100).toFixed(0) }}% Lokal
                              </p>
                            </div>
                            <div class="mt-1 d-inline-flex align-items-center gap-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="
                                                    background: rgba(255, 136, 0, 1);
                                                    width: 50px;
                                                "
                              ><a v-if="mainNamaSubKontraktorNonLokal.length > 0" data-bs-toggle="modal" data-bs-target="#subKontraktorNonLokal" style="font-size: 12px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="subKontraktorNonLokal" tabindex="-1" aria-labelledby="subKontraktorNonLokal" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Sub Kontraktor Non Lokal</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaSubKontraktorNonLokal" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                {{(totalSubKontraktorNonLokal/totalSubKontraktor*100).toFixed(0)}}% Non Lokal
                              </p>
                            </div>
                          </div>
                          <div
                              class="col-md-7 align-items-center py-3"
                              v-if="userData.role !== 'kontraktor'"
                          >
                            <canvas
                                id="subKontraktorLokalNonLokal"
                                width="10"
                                height="10"
                                class=""
                            ></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card p-3 mb-2 border-0 shadow-lg">
                        <div class="row">
                          <p class="text-secondary mb-1" style="font-size: 11px;color: #555770;">
                            Sub Kontraktor
                          </p>
                          <p class="text-secondary fw-bolder" style="font-size: 14px">
                            Berdasarkan Kualifikasi Usaha
                          </p>
                          <div class="col-md-5 col-sm-12 p-1 mt-4">
                            <div class="d-inline-flex align-items-center gap-1 mt-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="background: rgb(222,156,159); width: 50px;"
                              ><a v-if="(mainNamaSubKontraktorBesar != null)" data-bs-toggle="modal" data-bs-target="#subNamaKontraktorUsahaBesar" style="font-size: 12px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="subNamaKontraktorUsahaBesar" tabindex="-1" aria-labelledby="subNamaKontraktorUsahaBesar" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Sub Kontraktor Besar</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaSubKontraktorBesar" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                {{ (totalSubKontraktorBesar/totalSubKontraktor*100).toFixed(0) }}% Besar
                              </p>
                            </div>
                            <div class="mt-1 d-inline-flex align-items-center gap-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="
                                                    background: rgb(246,133,133);
                                                    width: 50px;
                                                "
                              ><a v-if="mainNamaSubKontraktorSedang != null" data-bs-toggle="modal" data-bs-target="#subNamaKontraktorUsahaSedang" style="font-size: 12px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="subNamaKontraktorUsahaSedang" tabindex="-1" aria-labelledby="subNamaKontraktorUsahaSedang" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Sub Kontraktor Sedang</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaSubKontraktorSedang" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                {{ (totalSubKontraktorSedang/totalSubKontraktor*100).toFixed(0) }}% Sedang
                              </p>
                            </div>
                            <div class="mt-1 d-inline-flex align-items-center gap-1">
                              <div
                                  class="border border-0 border-black p-1 rounded-1"
                                  style="
                                                    background: rgb(243,86,86);
                                                    width: 50px;
                                                "
                              ><a v-if="mainNamaSubKontraktorKecil != null" data-bs-toggle="modal" data-bs-target="#subNamaKontraktorUsahaKecil" style="font-size: 12px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                              <div class="modal fade rounded-top-5" id="subNamaKontraktorUsahaKecil" tabindex="-1" aria-labelledby="subNamaKontraktorUsahaKecil" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Sub Kontraktor Kecil</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                No.
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                Nama Kontraktor
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in mainNamaSubKontraktorKecil" :key="index">
                                              <td>{{ index+1 }}</td>
                                              <td>{{ item.toString() }}</td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                {{ (totalSubKontraktorKecil/totalSubKontraktor*100).toFixed(0) }}% Kecil
                              </p>
                            </div>
                          </div>
                          <div
                              class="col-md-7 align-items-center py-3"
                              v-if="userData.role !== 'kontraktor'"
                          >
                            <canvas
                                id="subKontraktorKualifikasiUsaha"
                                width="10"
                                height="10"
                                class=""
                            ></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                <div class="container" v-if="userData.role !== 'kontraktor'">
                  <div class="row p-2">
                    <div class="card shadow-lg rounded-4 border-0 mt-lg-3 col-md-12 p-2">
                      <div>
                        <h3 class="px-3 pt-4 text-black fw-bolder">Total Kontraktor : {{ totalAllKontraktor }}</h3>
                        <p class=" px-3 fst-italic text-secondary-emphasis" style="font-size: 12px">* Total Data Kontraktor dan SubKontraktor yang sudah teraggregasi jika Main Kontraktor juga sebagai Subkontraktor</p>
                      </div>
                      <div class="row p-3">
                        <div class="col-md-4">
                            <div class="card p-3 mb-2 border-0 shadow-lg">
                                <div class="row">
                                    <p class="text-secondary mb-1" style="font-size: 11px;color: #555770;">
                                      Kontraktor
                                    </p>
                                    <p class="text-secondary fw-bolder" style="font-size: 14px">
                                        Inti & Non Inti
                                    </p>
<!--                                    <p class="fst-italic text-secondary-emphasis" style="font-size: 9px">
                                      * Total Data Kontraktor dan Sub Kontraktor
                                    </p>-->
                                    <div class="col-md-5 col-sm-12 p-2">
<!--                                        <p class="text-secondary">Total Kontraktor</p>
                                        <h2 class="text-black fw-bolder">
                                            {{ totalKontraktorInternalIntiNon }}
                                        </h2>-->
                                        <div class="mt-2 d-inline-flex align-items-center gap-1 mt-5">
                                            <div
                                                class="border border-0 border-black p-1 rounded-1"
                                                style="background: rgba(181, 26, 26, 1); width: 50px"
                                            ><a v-if="mainNamaAllKontraktorInti.length > 0" data-bs-toggle="modal" data-bs-target="#mainAllKontraktorInti" style="font-size: 12px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                            <div class="modal fade rounded-top-5" id="mainAllKontraktorInti" tabindex="-1" aria-labelledby="mainAllKontraktorInti" aria-hidden="true">
                                            <div class="modal-dialog-centered rounded-top-5">
                                              <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                   style="min-height: 156px; min-width: 350px;">
                                                <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                     style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                                  <div class="d-flex justify-content-end w-100 p-2">
                                                    <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                                      <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                                    </button>
                                                  </div>
                                                  <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                                    <h4 class="fw-bold">Kontraktor Inti</h4>
                                                  </div>
                                                </div>
                                                <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                                  <div class="p-3">
                                                    <div class="table-responsive">
                                                      <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                                        <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                                        <tr class="table-danger">
                                                          <th class="p-2 text-nowrap" style="width: 10%">
                                                            No.
                                                          </th>
                                                          <th class="p-2 text-nowrap" style="width: 90%">
                                                            Nama Kontraktor
                                                          </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                                        <tr v-for="(item, index) in mainNamaAllKontraktorInti" :key="index">
                                                          <td>{{ index+1 }}</td>
                                                          <td>{{ item.toString() }}</td>
                                                        </tr>
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                            <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                                {{ totalPersentasiKonInti }}% Inti
                                            </p>
                                        </div>
                                        <div class="mt- d-inline-flex align-items-center gap-1 mt-1">
                                                <div
                                                    class="border border-0 border-black p-1 rounded-1"
                                                    style="
                                                        background: rgba(255, 128, 128, 1);
                                                        width: 50px;
                                                    "
                                                ><a v-if="mainNamaAllKontraktorNonInti.length > 0" data-bs-toggle="modal" data-bs-target="#mainAllKontraktorNonInti" style="font-size: 12px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                                <div class="modal fade rounded-top-5" id="mainAllKontraktorNonInti" tabindex="-1" aria-labelledby="mainAllKontraktorNonInti" aria-hidden="true">
                                                  <div class="modal-dialog-centered rounded-top-5">
                                                    <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                         style="min-height: 156px; min-width: 350px;">
                                                      <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                           style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                                        <div class="d-flex justify-content-end w-100 p-2">
                                                          <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                                            <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                                          </button>
                                                        </div>
                                                        <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                                          <h4 class="fw-bold">Kontraktor Non Inti</h4>
                                                        </div>
                                                      </div>
                                                      <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                                        <div class="p-3">
                                                          <div class="table-responsive">
                                                            <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                                              <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                                              <tr class="table-danger">
                                                                <th class="p-2 text-nowrap" style="width: 10%">
                                                                  No.
                                                                </th>
                                                                <th class="p-2 text-nowrap" style="width: 90%">
                                                                  Nama Kontraktor
                                                                </th>
                                                              </tr>
                                                              </thead>
                                                              <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                                              <tr v-for="(item, index) in mainNamaAllKontraktorNonInti" :key="index">
                                                                <td>{{ index+1 }}</td>
                                                                <td>{{ item.toString() }}</td>
                                                              </tr>
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                                    {{ totalPersentasiKonNonInti }}% Non Inti
                                                </p>
                                            </div>
                                    </div>
                                    <div
                                        class="col-md-7 align-items-center py-3"
                                        v-if="userData.role !== 'kontraktor'"
                                    >
                                        <canvas
                                            id="KontraktorIntiNonInti"
                                            width="10"
                                            height="10"
                                            class=""
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card p-3 mb-2 border-0 shadow-lg">
                                <div class="row">
                                    <p class="text-secondary mb-1" style="font-size: 11px;color: #555770;">
                                      Kontraktor
                                    </p>
                                    <p class="text-secondary fw-bolder" style="font-size: 14px">
                                        Lokal & Non-Lokal
                                    </p>
<!--                                    <p class="fst-italic text-secondary-emphasis" style="font-size: 9px">
                                      * Total Data Kontraktor dan Sub Kontraktor
                                    </p>-->
                                    <div class="col-md-5 col-sm-12 p-2">
<!--                                        <p class="text-secondary">Total Kontraktor</p>
                                        <h2 class="text-black fw-bolder">
                                            {{ totalKontraktorInternalLokalNon }}
                                        </h2>-->
                                        <div class="mt-2 d-inline-flex align-items-center gap-1 mt-5">
                                            <div
                                                class="border border-0 border-black p-1 rounded-1"
                                                style="background: rgba(252, 204, 117, 1); width: 50px"
                                            ><a v-if="mainNamaAllKontraktorLokal.length > 0" data-bs-toggle="modal" data-bs-target="#mainAllKontraktorLokal" style="font-size: 12px;color: black; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                            <div class="modal fade rounded-top-5" id="mainAllKontraktorLokal" tabindex="-1" aria-labelledby="mainAllKontraktorLokal" aria-hidden="true">
                                            <div class="modal-dialog-centered rounded-top-5">
                                              <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                   style="min-height: 156px; min-width: 350px;">
                                                <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                     style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                                  <div class="d-flex justify-content-end w-100 p-2">
                                                    <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                                      <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                                    </button>
                                                  </div>
                                                  <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                                    <h4 class="fw-bold">Kontraktor Lokal</h4>
                                                  </div>
                                                </div>
                                                <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                                  <div class="p-3">
                                                    <div class="table-responsive">
                                                      <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                                        <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                                        <tr class="table-danger">
                                                          <th class="p-2 text-nowrap" style="width: 10%">
                                                            No.
                                                          </th>
                                                          <th class="p-2 text-nowrap" style="width: 90%">
                                                            Nama Kontraktor
                                                          </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                                        <tr v-for="(item, index) in mainNamaAllKontraktorLokal" :key="index">
                                                          <td>{{ index+1 }}</td>
                                                          <td>{{ item.toString() }}</td>
                                                        </tr>
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                            <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                                {{ totalPersentasiKontraktorLokal }}% Lokal
                                            </p>
                                        </div>
                                        <div>
                                            <div class="mt- d-inline-flex align-items-center gap-1 mt-1">
                                                <div
                                                    class="border border-0 border-black p-1 rounded-1"
                                                    style="
                                                        background: rgba(255, 136, 0, 1);
                                                        width: 50px;
                                                    "
                                                ><a v-if="mainNamaAllKontraktorNonLokal.length > 0" data-bs-toggle="modal" data-bs-target="#mainAllKontraktorNonLokal" style="font-size: 12px;color: white; margin: 0;cursor: pointer;text-decoration: none;">Detail</a></div>
                                                <div class="modal fade rounded-top-5" id="mainAllKontraktorNonLokal" tabindex="-1" aria-labelledby="mainAllKontraktorNonLokal" aria-hidden="true">
                                                <div class="modal-dialog-centered rounded-top-5">
                                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                       style="min-height: 156px; min-width: 350px;">
                                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                                      <div class="d-flex justify-content-end w-100 p-2">
                                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                                        </button>
                                                      </div>
                                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                                        <h4 class="fw-bold">Kontraktor Non Lokal</h4>
                                                      </div>
                                                    </div>
                                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                                      <div class="p-3">
                                                        <div class="table-responsive">
                                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                                            <thead style="font-weight: 500; font-size: 10px; color: #28293d">
                                                            <tr class="table-danger">
                                                              <th class="p-2 text-nowrap" style="width: 10%">
                                                                No.
                                                              </th>
                                                              <th class="p-2 text-nowrap" style="width: 90%">
                                                                Nama Kontraktor
                                                              </th>
                                                            </tr>
                                                            </thead>
                                                            <tbody style="font-weight: 500; font-size: 10px; color: #28293d" class="p-3">
                                                            <tr v-for="(item, index) in mainNamaAllKontraktorNonLokal" :key="index">
                                                              <td>{{ index+1 }}</td>
                                                              <td>{{ item.toString() }}</td>
                                                            </tr>
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                                <p class="text-black fw-bolder" style="font-size: 12px; margin: 0">
                                                    {{ totalPersentasiKontraktorNonLokal }}% Non Lokal
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-7 align-items-center py-3">
                                        <canvas
                                            id="KontraktorLokalNonLokal"
                                            width="10"
                                            height="10"
                                            class=""
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                          <div class="card p-3 mb-2 border-0 shadow-lg" style="height: 320px;">
                            <h8 class="px-1 pt-4 text-black fw-bolder">
                              Daftar IUJP yang akan berakhir
                            </h8>
                            <div class="row p-1">
                              <div class="d-flex justify-content-between mb-0">
                                <div class="d-flex d-inline-block">
                                  <a
                                      data-bs-toggle="modal" data-bs-target="#lihatLainIUJP"
                                      v-if="expAllIujp.length > 3"
                                      class="text-decorat fw-bolder"
                                      style="font-size: 14px; color: rgba(181, 26, 26, 1); cursor: pointer;"
                                  >
                                    Lihat Lainnya
                                    <font-awesome-icon :icon="['fas', 'arrow-right-long']" />
                                  </a>
                                </div>
                              </div>
                              <div class="modal fade rounded-top-5" id="lihatLainIUJP" tabindex="-1" aria-labelledby="lihatLainIUJP" aria-hidden="true">
                                <div class="modal-dialog-centered rounded-top-5">
                                  <div class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                       style="min-height: 156px; min-width: 350px;">
                                    <div class=" modal-content rounded-bottom-5 rounded-top-4 border-0"
                                         style="min-height: 100px; min-width:  350px; background: rgba(181, 26, 26, 1);">
                                      <div class="d-flex justify-content-end w-100 p-2">
                                        <button type="button" id="btnClose" class="btn" data-bs-dismiss="modal" aria-label="Close">
                                          <img src="../../assets/icons/close_whaite.png" alt="icon" width="24" height="24">
                                        </button>
                                      </div>
                                      <div class="p-3 text-white text-center mb-3" style="font-family: Inter, sans-serif">
                                        <h4 class="fw-bold">Daftar IUJP yang akan berakhir</h4>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="height: 50vh;overflow-y: auto;">
                                      <div class="p-3">
                                        <div class="table-responsive">
                                          <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                            <thead style="font-weight: 500; font-size: 14px; color: #28293d">
                                            <tr class="table-danger">
                                              <th class="p-2 text-nowrap" style="width: 55%">
                                                Nama Kontraktor
                                              </th>
                                              <th class="p-2 text-nowrap" style="width: 45%">
                                                Tanggal Berakhir IUJP
                                              </th>
                                            </tr>
                                            </thead>
                                            <tbody style="font-weight: 500; font-size: 14px; color: #28293d" class="p-3">
                                            <tr v-for="(item, index) in expAllIujp" :key="index">
                                              <td>{{ item.namaKontraktor }}</td>
                                              <td>
                                                {{ moment(item.tglExpIujp).format("DD/MMM/YYYY") }}
                                              </td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="table-responsive">
                                <table class="table mb-0" style="font-family: 'Inter-Regular', serif">
                                  <thead style="font-weight: 500; font-size: 14px; color: #28293d">
                                  <tr class="table-danger">
                                    <th class="p-2 text-nowrap" style="width: 55%">
                                      Nama Kontraktor
                                    </th>
                                    <th class="p-2 text-nowrap" style="width: 45%">
                                      Tanggal Berakhir IUJP
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody style="font-weight: 500; font-size: 14px; color: #28293d" class="p-3">
                                  <tr v-for="(item, index) in expIujp" :key="index">
                                    <td>{{ item.namaKontraktor }}</td>
                                    <td>
                                      {{ moment(item.tglExpIujp).format("DD/MMM/YYYY") }}
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--End Admin atau Isafe-->
            </div>
        </main>
    </section>
    <ModalComponent
      id="update-no-handphone"
      title="Peringatan!"
      description="Mohon untuk lengkapi data profil anda, silahkan mengisi nomor handphone pada inputan yang tersedia di bawah."
      :button="isNoHpValid === null ? true : !isNoHpValid"
      :modalType="1"
      :btnClosed="false"
      @click-submit="submitUpdateNoHandphone"
      style="z-index: 1060"
    >
    <div class="col-md-12">
      <label for="nohp" class="form-label fs-8 fw-bold">
        No Handphone
      </label>
      <input 
        type="text" 
        class="form-control fs-9" 
        placeholder="Format 628xxx | Karakter min 9, Max 14" 
        id="nohp" @input="validatePhoneEdit"
        :class="{ 'is-invalid': isNoHpValid === false, 'is-valid': isNoHpValid === true}" 
        v-model="FormValuesEdit.noHandphone"
      />
    </div>
    </ModalComponent>
</template>

<script>
import SidebarComponent from "@/components/SideBar.vue"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import GlobalDataMixin from "../../GlobalDataMixin"
import Chart from "chart.js/auto"
import {
  API_BASE_URL,
  CMS_DASHBOARD,
  IUJP_EXP,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_KONTRAK,
  CMS_GET_SIOID,
  CMS_DASHBOARD_SIO,
  CMS_GET_DASHBOARD_IMKP, CMS_GET_USER_DETAIL,
  CMS_GET_USER_UPDATE
} from "@/constants"
import axios from "axios"
import Swal from "sweetalert2";
import ModalComponent from "@/components/ModalComponent.vue";
import {
  refreshUserData,
} from "@/utilities/globalFunction";

const url_data_dashboard = API_BASE_URL + CMS_DASHBOARD
const url_detail_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR
const url_data_kontrak = API_BASE_URL + CMS_KONTRAK;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_get_dashboard_sio = API_BASE_URL + CMS_DASHBOARD_SIO;
const url_get_dashboard_imkp = API_BASE_URL + CMS_GET_DASHBOARD_IMKP;
const url_get_user_detail = API_BASE_URL + CMS_GET_USER_DETAIL;

export default {
    mixins: [GlobalDataMixin],
    name: "DashboardPage",
    components: {
        FontAwesomeIcon,
        SidebarComponent,
        ModalComponent
    },
    data() {
        return {
            link: "/profile",
            linkContract: "/kontrak",
            linkSio: "/sio",
            totalKontrakAktif: 0,
            totalKontrakSelesai: 0,
            totalKontrak: 0,

            totalSubKonInti: 0,
            totalSubkonNonInti: 0,
            totalSubKontraktorIntiNon: 0,
            totalPersentasiSubKonInti: 0,
            totalPersentasiSubKonNonInti: 0,

            totalSubKontraktorLokal: 0,
            totalSubKontraktorNonlokal: 0,
            totalSubKontLokalNon: 0,
            totalSubKontraktorLokalNon: 0,
            totalPersentasiSubKonNonLokal: 0,
            totalPersentasiSubKonLokal: 0,
            totalPersentasiSubKonLokalNonLokal: 0,

            totalKontrakInternalAktif: 0,
            totalKontrakInternalSelesai: 0,
            totalKontrakInternal: 0,

            totalKontraktorInternalIntiNon: 0,
            totalKontraktorInternalInti: 0,
            totalKontraktorInternalNonInti: 0,
            totalPersentasiKonInti: 0,
            totalPersentasiKonNonInti: 0,

            totalKontraktorInternalLokalNon: 0,
            totalKontraktorInternalLokal: 0,
            totalKontraktorInternalNonLokal: 0,
            totalPersentasiKontraktorLokal: 0,
            totalPersentasiKontraktorNonLokal: 0,

            totalMainKontraktor: 0,
            totalAllKontraktor: 0,

            expIujp: [],
            rowLimit: 3,
            expAllIujp: [],
            isModalVisible: false,
            kontraktor: [],
            isExpIujp : false,
            tglExpIujp : '',
            kontrak: [],
            ruangLingkupArr: [],
            ruangLingkupArr2: [],
            ruangLingkupArr3: [],

            kontraktorKritis: 0,
            kontraktorTinggi: 0,
            kontraktorSedang: 0,
            kontraktorRendah: 0,
            totalKontraktorbyTingkatResiko : 0,

            mainKontraktorInti: 0,
            mainKontraktorNonInti: 0,
            totalMainIntiNonInti: 0,

            mainKontraktorLokal: 0,
            mainKontraktorNonLokal: 0,
            totalMainLokalNonLokal: 0,

            mainKontraktorBesar: 0,
            mainKontraktorSedang: 0,
            mainKontraktorKecil: 0,
            totalMainKualifikasiUsaha: 0,

            totalSubKontraktor: 0,
            totalSubKontraktorInti: 0,
            totalSubKontraktorNonInti: 0,
            totalSubKontraktorLokals: 0,
            totalSubKontraktorNonLokal: 0,
            totalSubKontraktorBesar: 0,
            totalSubKontraktorSedang: 0,
            totalSubKontraktorKecil: 0,

            dataSio : [],
            progressSio: 20,
            dataDashboardSIO:{
                totalPengajuan:null,
                totalPersyaratanAdministratif: null,
                totalPembuatanJadwal: null,
                totalPresentasi: null,
                totalPemenuhanNc: null,
                totalProsesSuratPengesahan : null,
                totalSuratPengesahan: null,
                totalSioApproved: null,
                kontraktorPersyaratanAdministratif: [],
                kontraktorPembuatanJadwal: [],
                kontraktorPresentasi: []
            },
            mainNamaKontraktorInti: [],
            mainNamaKontraktorNonInti : [],
            mainNamaKontraktorLokal: [],
            mainNamaKontraktorNonLokal : [],
            mainNamaKontraktorKritis: [],
            mainNamaKontraktorTinggi : [],
            mainNamaKontraktorSedang: [],
            mainNamaKontraktorRendah : [],
            mainNamaKontraktorUsahaBesar : [],
            mainNamaKontraktorUsahaSedang : [],
            mainNamaKontraktorUsahaKecil : [],
            mainNamaSubKontraktorInti: [],
            mainNamaSubKontraktorNonInti: [],
            mainNamaSubKontraktorLokal: [],
            mainNamaSubKontraktorNonLokal: [],
            mainNamaSubKontraktorBesar: [],
            mainNamaSubKontraktorSedang: [],
            mainNamaSubKontraktorKecil: [],
            mainNamaAllKontraktorInti: [],
            mainNamaAllKontraktorNonInti : [],
            mainNamaAllKontraktorLokal: [],
            mainNamaAllKontraktorNonLokal : [],

            dataDashboardImkp: {
              totalImkp: 0,
              totalImkpUnderReview: 0,
              totalNeedRevision: 0,
              totalDocumentComplete: 0,
              totalProsesPenerbitanImkp: 0,
              totalImkpPublished: 0,
              totalProccessBast: 0,
              totalBastDone: 0,
            },
            userDetail  :null,
          FormValuesEdit: {
            userId: "",
            email: "",
            kontraktorId: null,
            noHandphone: "",
          },
          isNoHpValid: null,
        }
    },
    computed() {
      if (this.userData) {
        this.$router.replace("/")
      }
    },
    mounted() {
        this.fetchDataDashboard()
        this.ChartRenderInternal()
        this.ChartKontraktor()
        this.dataIujpExp()
        this.fetchDataKontraktor()
        this.getSioID()
        this.ChartTotalSIO()
        this.totalImkp()
      if (this.userData.kontraktorID) {
        this.getUserDetail()
      }
    },
    methods: {
        // Fetch latest user data from backend and update localStorage + component state
        async refreshDashboardUserData() {
          try {
            const updated = await refreshUserData(this.userData)
            this.userData = updated
          } catch (err) {
            console.error("[DashboardPage] Failed to refresh user data:", err)
          }
        },
        showModal() {
          this.isModalVisible = true;
        },
        hideModal() {
          this.isModalVisible = false;
        },
        filteredItems() {
          // Adjust the condition based on your requirement
          return this.ruangLingkupArr3.filter(item => item.length > 0);
        },
        getInitials(fullName) {
            if (fullName && typeof fullName === "string") {
                const words = fullName.split(" ")
                let initials = ""

                if (words.length === 1) {
                    initials = words[0].substring(0, 2).toUpperCase()
                } else {
                    for (let i = 0; i < 2 && i < words.length; i++) {
                        initials += words[i].charAt(0).toUpperCase()
                    }
                }
                return initials
            } else {
                return ""
            }
        },
        fetchDataKontraktor() {
          if(this.userData.kontraktorID != null) {
            axios
                .get(url_detail_kontraktor + this.userData.kontraktorID, {headers: {accept: "application/json"}})
                .then((response) => {
                  this.kontraktor = response.data.detailKontraktor
                  this.tglExpIujp = moment(response.data.detailKontraktor.masaBerlaku).format('YYYY-MM-DD')
                  const currentDate = new Date();
                  const sixMonthsLaterDate = new Date();
                  const resultDate = sixMonthsLaterDate.setMonth(currentDate.getMonth() + 6);
                  if(this.tglExpIujp < moment(resultDate).format('YYYY-MM-DD')){
                      this.isExpIujp = true
                  }
                  // set value form edit
                })
                .catch((error) => {
                  alert("Error Fetch Data List Kontraktor : " + error.message)
                  console.error("Error fetching data:", error)
                })
          }
        },
        fetchDataDashboard() {
            let bodyJSONCreate = { role: "isafe", kontraktorId: null }
            if (this.userData.kontraktorID != null) {
                bodyJSONCreate = {
                    role: "kontraktor",
                    kontraktorId: this.userData.kontraktorID,
                }
            }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let config = {
                headers: {
                    role: role,
                    Authorization: `Bearer ${tokens.token}`,
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                },
            }
            axios
                .post(url_data_dashboard, bodyJSONCreate, config)
                .then((response) => {
                    if (this.userData.kontraktorID != null) {
                        this.totalKontrakAktif = JSON.stringify(
                            response.data.dataKontraktor.totalKontrakAktif
                        )
                        this.totalKontrakSelesai = JSON.stringify(
                            response.data.dataKontraktor.totalKontrakNonAktif
                        )
                        this.totalKontrak =
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalKontrakAktif)
                            ) +
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalKontrakNonAktif)
                            )

                        let totalSubKont =
                            parseInt(JSON.stringify(response.data.dataKontraktor.totalSubkonInti)) +
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonNonInti)
                            )
                        this.totalSubKontraktorIntiNon = totalSubKont
                        this.totalPersentasiSubKonInti = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonInti)
                            ) /
                                (totalSubKont == 0 ? 1 : totalSubKont)) *
                                100
                        )
                        this.totalPersentasiSubKonNonInti = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonNonInti)
                            ) /
                                (totalSubKont == 0 ? 1 : totalSubKont)) *
                                100
                        )

                        let totalSubKontLokalNon =
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonLokal)
                            ) +
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonNonLokal)
                            )
                        this.totalSubKontraktorNonlokal = JSON.stringify(
                            response.data.dataKontraktor.totalSubkonNonLokal
                        )
                        this.totalSubKontraktorLokalNon = totalSubKontLokalNon
                        this.totalPersentasiSubKonLokal = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonLokal)
                            ) /
                                (totalSubKontLokalNon == 0 ? 1 : totalSubKontLokalNon)) *
                                100
                        )
                        this.totalPersentasiSubKonNonLokal = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonNonLokal)
                            ) /
                                (totalSubKontLokalNon == 0 ? 1 : totalSubKontLokalNon)) *
                                100
                        )

                        // fetch data kontrak
                        var bodyJson = {
                          header: {
                            page: 1,
                            perPage: 1000,
                            usecase: this.userData.kontraktorID != null ? "kontraktor" : "isafe",
                          },
                          kontraktorID: this.userData.kontraktorID != null ? this.userData.kontraktorID : null,
                        };
                        const user = localStorage.getItem("user_cms");
                        const tokens = JSON.parse(user);
                        const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe";
                        var config = {
                          headers: {
                            role: role,
                            Authorization: `Bearer ${tokens.token}`,
                            Accept: "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                            "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                          },
                        }
                        console.log('body:',bodyJson);
                        axios
                            .post(url_data_kontrak, bodyJson, config)
                            .then((response) => {
                              this.kontrak = response.data.data
                              this.ruangLingkupArr = response.data.data.map(item => ({...item, descriptionLine: (item.ruangLingkup.split('\n'))}))
                              this.ruangLingkupArr.forEach(
                                  item => {
                                    if(item.descriptionLine.length > 1) {
                                      this.ruangLingkupArr2.push(item.descriptionLine)
                                    }
                                    else if(item.ruangLingkup !== ""){
                                      this.ruangLingkupArr2.push(item.ruangLingkup)
                                    }
                                  }
                              )
                              console.log("arr 1", this.ruangLingkupArr)
                              console.log("arr 2", this.ruangLingkupArr2)
                              this.ruangLingkupArr3 = [].concat(...this.ruangLingkupArr2.map(obj => obj))
                            })
                            .catch((error) => {
                              if(error.responsestatus!=400){
                                alert("Error Fetch Data List Kontrak : " + error.message)
                                console.error("Error fetching data:", error)
                              }else{
                                this.kontrak=[];
                              }

                            })
                    } else {
                        this.totalKontrakInternalAktif = JSON.stringify(
                            response.data.dataInternal.totalKontrakAktif
                        )
                        this.totalKontrakInternalSelesai = JSON.stringify(
                            response.data.dataInternal.totalKontrakNonAktif
                        )
                        this.totalKontrakInternal =
                            parseInt(JSON.stringify(response.data.dataInternal.totalKontrakAktif)) +
                            parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontrakNonAktif)
                            )
                        this.totalKontraktorInternalIntiNon =
                            parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorInti)
                            ) + parseInt(response.data.dataInternal.totalKontraktorNonInti)
                        this.totalPersentasiKonInti = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorInti)
                            ) /
                                (parseInt(
                                    JSON.stringify(response.data.dataInternal.totalKontraktorInti)
                                ) +
                                    parseInt(response.data.dataInternal.totalKontraktorNonInti))) *
                                100
                        )
                        this.totalPersentasiKonNonInti = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorNonInti)
                            ) /
                                (parseInt(
                                    JSON.stringify(response.data.dataInternal.totalKontraktorInti)
                                ) +
                                    parseInt(response.data.dataInternal.totalKontraktorNonInti))) *
                                100
                        )

                        this.totalKontraktorInternalLokalNon =
                            parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorLokal)
                            ) + parseInt(response.data.dataInternal.totalKontraktorNonLokal)
                        this.totalPersentasiKontraktorLokal = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorLokal)
                            ) /
                                (parseInt(
                                    JSON.stringify(response.data.dataInternal.totalKontraktorLokal)
                                ) +
                                    parseInt(response.data.dataInternal.totalKontraktorNonLokal))) *
                                100
                        )
                        this.totalPersentasiKontraktorNonLokal = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorNonLokal)
                            ) /
                                (parseInt(
                                    JSON.stringify(response.data.dataInternal.totalKontraktorLokal)
                                ) +
                                    parseInt(response.data.dataInternal.totalKontraktorNonLokal))) *
                                100
                        )
                        this.kontraktorKritis = parseInt(JSON.stringify(response.data.dataInternal.totalKontraktorKritis))
                        this.kontraktorTinggi = parseInt(JSON.stringify(response.data.dataInternal.totalKontraktorTinggi))
                        this.kontraktorSedang = parseInt(JSON.stringify(response.data.dataInternal.totalKontraktorSedang))
                        this.kontraktorRendah = parseInt(JSON.stringify(response.data.dataInternal.totalKontraktorRendah))
                        this.totalKontraktorbyTingkatResiko = this.kontraktorKritis + this.kontraktorTinggi + this.kontraktorSedang + this.kontraktorRendah

                        this.mainKontraktorInti = parseInt(JSON.stringify(response.data.dataInternal.totalMainKontraktorInti))
                        this.mainKontraktorNonInti = parseInt(JSON.stringify(response.data.dataInternal.totalMainKontraktorNonInti))
                        this.totalMainIntiNonInti = this.mainKontraktorInti + this.mainKontraktorNonInti
                        this.mainNamaKontraktorInti = response.data.dataInternal.mainKontraktorInti.split(",")
                        this.mainNamaKontraktorNonInti = response.data.dataInternal.mainKontraktorNonInti.split(",")
                        this.mainKontraktorLokal = parseInt(JSON.stringify(response.data.dataInternal.totalMainKontraktorLokal))
                        this.mainKontraktorNonLokal = parseInt(JSON.stringify(response.data.dataInternal.totalMainKontraktorNonLokal))
                        this.totalMainLokalNonLokal = this.mainKontraktorLokal + this.mainKontraktorNonLokal
                        this.totalMainKontraktor = parseInt(JSON.stringify(response.data.dataInternal.totalMainKontraktor))
                        this.totalAllKontraktor = parseInt(JSON.stringify(response.data.dataInternal.totalKontraktor))
                        this.mainNamaAllKontraktorInti = response.data.dataInternal.allKontraktorInti.split(",")
                        this.mainNamaAllKontraktorNonInti = response.data.dataInternal.allKontraktorNonInti.split(",")
                        this.mainNamaAllKontraktorLokal = response.data.dataInternal.allKontrakotrLokal.split(",")
                        this.mainNamaAllKontraktorNonLokal = response.data.dataInternal.allKontraktorNonLokal.split(",")
                        this.mainNamaKontraktorLokal = response.data.dataInternal.mainKontraktorLokal.split(",")
                        this.mainNamaKontraktorNonLokal = response.data.dataInternal.mainKontraktorNonLokal.split(",")
                        this.mainNamaKontraktorKritis = response.data.dataInternal.mainKontraktorTrKritis != null ? response.data.dataInternal.mainKontraktorTrKritis.split(",") : null
                        this.mainNamaKontraktorTinggi = response.data.dataInternal.mainKontraktorTrTinggi != null ? response.data.dataInternal.mainKontraktorTrTinggi.split(",") : null
                        this.mainNamaKontraktorSedang= response.data.dataInternal.mainKontraktorTrSedang != null ? response.data.dataInternal.mainKontraktorTrSedang.split(",") : null
                        this.mainNamaKontraktorRendah = response.data.dataInternal.mainKontraktorTrRendah != null ? response.data.dataInternal.mainKontraktorTrRendah.split(",") : null
                    }
                })
                .catch((error) => {
                    console.error("Error fetching data:", error)
                })
        },
        dataIujpExp() {
            var bodyJson = {
                page: 1,
                perPage: 3,
                usecase: "isafe",
            }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            axios
                .post(API_BASE_URL + IUJP_EXP, bodyJson, {
                    headers: {
                        role: "isafe",
                        Authorization: `Bearer ${tokens.token}`,
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                    },
                })
                .then((res) => {
                    this.expIujp = res.data.data.slice(0, this.rowLimit)
                    this.expAllIujp = res.data.data
                })
                .catch(() => {
                    console.log("error fetch data")
                })
        },
        ChartKontraktor() {
            let bodyJSONCreate = { role: "isafe", kontraktorId: null }
            if (this.userData.kontraktorID != null) {
                bodyJSONCreate = {
                    role: "kontraktor",
                    kontraktorId: this.userData.kontraktorID,
                }
            }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let config = {
                headers: {
                    role: role,
                    Authorization: `Bearer ${tokens.token}`,
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                },
            }
            axios
                .post(url_data_dashboard, bodyJSONCreate, config)
                .then((response) => {
                    this.totalSubKonInti = JSON.stringify(
                        response.data.dataKontraktor.totalSubkonInti
                    )
                    this.totalSubkonNonInti = JSON.stringify(
                        response.data.dataKontraktor.totalSubkonNonInti
                    )
                    this.totalSubKontraktorNonlokal = JSON.stringify(
                        response.data.dataKontraktor.totalSubkonNonLokal
                    )
                    this.totalSubKontraktorLokal = JSON.stringify(
                        response.data.dataKontraktor.totalSubkonLokal
                    )

                    const KontraktorLokalNonLokal =
                        document.getElementById("SubKonLokalSubNonLokal")
                    const DataOptionsKontraktorLokalNonLokal = {
                        labels: ["Lokal", "Non Lokal"],
                        datasets: [
                            {
                                label: "Total Subkontraktor",
                                data: [
                                    this.totalSubKontraktorLokal,
                                    this.totalSubKontraktorNonlokal,
                                ],
                                backgroundColor: ["rgba(255, 136, 0, 1)", "rgba(252, 204, 117, 1)"],
                                hoverOffset: 4,
                            },
                        ],
                    }
                    const OptionsKontraktorLokalNonLokal = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }
                    KontraktorLokalNonLokal
                        ? new Chart(KontraktorLokalNonLokal, {
                              type: "doughnut",
                              data: DataOptionsKontraktorLokalNonLokal,
                              options: OptionsKontraktorLokalNonLokal,
                          })
                        : console.log("Elemen Chart Kontraktor Lokal Non Lokal tidak ditemukan")
                    /* End Chart Kontraktor Lokal dan Non-Lokal */

                    /* Chart Kontraktor Inti dan Non-Inti */
                    const IntiNonInti = document.getElementById("SubKontIntiNonInti")
                    const a = this.totalSubKonInti
                    const b = this.totalSubkonNonInti
                    const data = {
                        labels: ["Inti", "Non Inti"],
                        datasets: [
                            {
                                label: "Total Subkontraktor",
                                data: [a, b],
                                backgroundColor: ["rgba(181, 26, 26, 1)", "rgba(255, 128, 128, 1)"],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const option = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }

                    IntiNonInti
                        ? new Chart(IntiNonInti, {
                              type: "doughnut",
                              data: data,
                              options: option,
                          })
                        : console.log("Elemen Chart Kontraktor Inti Non Inti tidak ditemukan")

                    /* End Chart Kontraktor Inti dan Non-Inti */
                })
                .catch((error) => {
                    console.error("Error fetching data:", error)
                })
        },

        ChartRenderInternal() {
            let bodyJSONCreate = { role: "isafe", kontraktorId: null }
            if (this.userData.kontraktorID != null) {
                bodyJSONCreate = {
                    role: "kontraktor",
                    kontraktorId: this.userData.kontraktorID,
                }
            }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let config = {
                headers: {
                    role: role,
                    Authorization: `Bearer ${tokens.token}`,
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                },
            }
            axios
                .post(url_data_dashboard, bodyJSONCreate, config)
                .then((response) => {
                    this.totalKontraktorInternalInti = JSON.stringify(
                        response.data.dataInternal.totalKontraktorInti
                    )
                    this.totalKontraktorInternalNonInti = JSON.stringify(
                        response.data.dataInternal.totalKontraktorNonInti
                    )
                    this.totalKontraktorInternalLokal = JSON.stringify(
                        response.data.dataInternal.totalKontraktorLokal
                    )
                    this.totalKontraktorInternalNonLokal = JSON.stringify(
                        response.data.dataInternal.totalKontraktorNonLokal
                    )
                    this.kontraktorKritis = JSON.stringify(
                        response.data.dataInternal.totalKontraktorKritis
                    )
                    this.kontraktorTinggi = JSON.stringify(
                        response.data.dataInternal.totalKontraktorTinggi
                    )
                    this.kontraktorSedang = JSON.stringify(
                        response.data.dataInternal.totalKontraktorSedang
                    )
                    this.kontraktorRendah = JSON.stringify(
                        response.data.dataInternal.totalKontraktorRendah
                    )
                    this.mainKontraktorInti = JSON.stringify(
                        response.data.dataInternal.totalMainKontraktorInti
                    )
                    this.mainKontraktorNonInti = JSON.stringify(
                        response.data.dataInternal.totalMainKontraktorNonInti
                    )
                    this.mainKontraktorLokal = JSON.stringify(
                        response.data.dataInternal.totalMainKontraktorLokal
                    )
                    this.mainKontraktorNonLokal = JSON.stringify(
                        response.data.dataInternal.totalMainKontraktorNonLokal
                    )
                    this.mainKontraktorBesar =  parseInt(JSON.stringify(response.data.dataInternal.totalMainKontraktorBesar))
                    this.mainKontraktorSedang =  parseInt(JSON.stringify(response.data.dataInternal.totalMainKontraktorSedang))
                    this.mainKontraktorKecil =  parseInt(JSON.stringify(response.data.dataInternal.totalMainKontraktorKecil))
                    this.totalMainKualifikasiUsaha = this.mainKontraktorBesar + this.mainKontraktorSedang + this.mainKontraktorKecil
                    this.mainNamaKontraktorUsahaBesar = response.data.dataInternal.mainKontraktorBesar != null ? response.data.dataInternal.mainKontraktorBesar.split(",") : null
                    this.mainNamaKontraktorUsahaSedang = response.data.dataInternal.mainKontraktorSedang != null ? response.data.dataInternal.mainKontraktorSedang.split(",") : null
                    this.mainNamaKontraktorUsahaKecil = response.data.dataInternal.mainKontraktorKecil != null ? response.data.dataInternal.mainKontraktorKecil.split(",") : null
                    this.totalSubKontraktor = parseInt(JSON.stringify(response.data.dataInternal.totalSubKontraktor))
                    this.totalSubKontraktorInti = parseInt(JSON.stringify(response.data.dataInternal.totalSubKontraktorInti))
                    this.totalSubKontraktorNonInti = parseInt(JSON.stringify(response.data.dataInternal.totalSubKontraktorNonInti))
                    this.totalSubKontraktorLokals = parseInt(JSON.stringify(response.data.dataInternal.totalSubKontraktorLokal))
                    this.totalSubKontraktorNonLokal = parseInt(JSON.stringify(response.data.dataInternal.totalSubKontraktorNonLokal))
                    this.totalSubKontraktorBesar = parseInt(JSON.stringify(response.data.dataInternal.totalSubKontraktorBesar))
                    this.totalSubKontraktorSedang = parseInt(JSON.stringify(response.data.dataInternal.totalSubKontraktorSedang))
                    this.totalSubKontraktorKecil = parseInt(JSON.stringify(response.data.dataInternal.totalSubKontraktorKecil))
                    this.mainNamaSubKontraktorInti = response.data.dataInternal.subKontraktorInti != null ? response.data.dataInternal.subKontraktorInti.split(",") : null
                    this.mainNamaSubKontraktorNonInti = response.data.dataInternal.subKontraktorNonInti != null ? response.data.dataInternal.subKontraktorNonInti.split(",") : null
                    this.mainNamaSubKontraktorLokal = response.data.dataInternal.subKontraktorLokal != null ? response.data.dataInternal.subKontraktorLokal.split(",") : null
                    this.mainNamaSubKontraktorNonLokal = response.data.dataInternal.subKontraktorNonLokal!= null ? response.data.dataInternal.subKontraktorNonLokal.split(",") : null
                    this.mainNamaSubKontraktorBesar = response.data.dataInternal.subKontraktorBesar != null ? response.data.dataInternal.subKontraktorBesar.split(",") : null
                    this.mainNamaSubKontraktorSedang = response.data.dataInternal.subKontraktorSedang != null ? response.data.dataInternal.subKontraktorSedang.split(",") : null
                    this.mainNamaSubKontraktorKecil = response.data.dataInternal.subKontraktorKecil != null ? response.data.dataInternal.subKontraktorKecil.split(",") : null
                  /* Chart Kontraktor Inti dan Non-Inti */
                    const IntiNonInti = document.getElementById("KontraktorIntiNonInti")
                    const data = {
                        labels: ["Inti", "Non Inti"],
                        datasets: [
                            {
                                label: "Total Kontraktor",
                                data: [
                                    this.totalKontraktorInternalInti,
                                    this.totalKontraktorInternalNonInti,
                                ],
                                backgroundColor: ["rgba(181, 26, 26, 1)", "rgba(255, 128, 128, 1)"],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const option = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }

                    IntiNonInti
                        ? new Chart(IntiNonInti, {
                              type: "doughnut",
                              data: data,
                              options: option,
                          })
                        : console.log("Elemen Chart Kontraktor Inti Non Inti tidak ditemukan")

                    /* End Chart Kontraktor Inti dan Non-Inti */

                    /* Chart Kontraktor Lokal dan Non-Lokal */
                    const KontraktorLokalNonLokal =
                        document.getElementById("KontraktorLokalNonLokal")
                    const DataOptionsKontraktorLokalNonLokal = {
                        labels: ["Lokal", "Non Lokal"],
                        datasets: [
                            {
                                label: "Total Kontraktor",
                                data: [
                                    this.totalKontraktorInternalLokal,
                                    this.totalKontraktorInternalNonLokal,
                                ],
                                backgroundColor: ["rgba(252, 204, 117, 1)", "rgba(255, 136, 0, 1)"],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const OptionsKontraktorLokalNonLokal = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }
                    KontraktorLokalNonLokal
                        ? new Chart(KontraktorLokalNonLokal, {
                              type: "doughnut",
                              data: DataOptionsKontraktorLokalNonLokal,
                              options: OptionsKontraktorLokalNonLokal,
                          })
                        : console.log("Elemen Chart Kontraktor Lokal Non Lokal tidak ditemukan")
                    /* End Chart Kontraktor Lokal dan Non-Lokal */

                  /* Chart Kontraktor Tingkat Resiko */
                  const kontraktorTingkatResiko = document.getElementById("kontraktorTingkatResiko")
                  const dataKontTingkatResiko = {
                    labels: ["Kritis", "Tinggi", "Sedang", "Rendah"],
                    datasets: [
                      {
                        label: "Total Kontraktor",
                        data: [
                          this.kontraktorKritis,
                          this.kontraktorTinggi,
                          this.kontraktorSedang,
                          this.kontraktorRendah,
                        ],
                        backgroundColor: ["rgba(181,26,26,1)", "rgba(255, 92, 92, 1)","rgba(87,235,161, 1)", "rgb(252,204,117,1)"],
                        hoverOffset: 6,
                      },
                    ],
                  }
                  const optionTingkatReesiko = {
                    plugins: {
                      legend: {
                        position: "button",
                      },
                    },
                    cutoutPercentage: 80,
                  }

                  kontraktorTingkatResiko
                      ? new Chart(kontraktorTingkatResiko, {
                        type: "doughnut",
                        data: dataKontTingkatResiko,
                        options: optionTingkatReesiko,
                      })
                      : console.log("Elemen Chart Kontraktor Inti Non Inti tidak ditemukan")

                  /* End Chart Kontraktor Inti dan Non-Inti */

                  /* Chart Main Kontraktor Inti dan Non-Inti */
                  const mainIntiNonInti = document.getElementById("mainKontraktorIntiNonInti")
                  const dataMainIntiNonInti = {
                    labels: ["Inti", "Non Inti"],
                    datasets: [
                      {
                        label: "Total Kontraktor",
                        data: [
                          this.mainKontraktorInti,
                          this.mainKontraktorNonInti,
                        ],
                        backgroundColor: ["rgba(181, 26, 26, 1)", "rgba(255, 128, 128, 1)"],
                        hoverOffset: 10,
                      },
                    ]
                  }
                  const optionMainIntiNonInti = {
                    plugins: {
                      legend: {
                        position: "button"
                      }
                    },
                    cutoutPercentage: 100
                  }

                  mainIntiNonInti
                      ? new Chart(mainIntiNonInti, {
                        type: "doughnut",
                        data: dataMainIntiNonInti,
                        options: optionMainIntiNonInti,
                      })
                      : console.log("Elemen Chart Kontraktor Inti Non Inti tidak ditemukan")

                  /* End Chart Main Kontraktor Inti dan Non-Inti */

                  /* Chart Main Kontraktor Lokal dan Non-Lokal */
                  const mainKontraktorLokalNonLokal =
                      document.getElementById("mainKontraktorLokalNonLokal")
                  const DataOptionsMainKontraktorLokalNonLokal = {
                    labels: ["Lokal", "Non Lokal"],
                    datasets: [
                      {
                        label: "Total Kontraktor",
                        data: [
                          this.mainKontraktorLokal,
                          this.mainKontraktorNonLokal,
                        ],
                        backgroundColor: ["rgba(252, 204, 117, 1)", "rgba(255, 136, 0, 1)"],
                        hoverOffset: 6,
                      },
                    ],
                  }
                  const OptionsMainKontraktorLokalNonLokal = {
                    plugins: {
                      legend: {
                        position: "button",
                      },
                    },
                    cutoutPercentage: 80,
                  }
                  mainKontraktorLokalNonLokal
                      ? new Chart(mainKontraktorLokalNonLokal, {
                        type: "doughnut",
                        data: DataOptionsMainKontraktorLokalNonLokal,
                        options: OptionsMainKontraktorLokalNonLokal,
                      })
                      : console.log("Elemen Chart Kontraktor Lokal Non Lokal tidak ditemukan")
                  /* End Chart Main Kontraktor Lokal dan Non-Lokal */

                  /* Chart Main Kontraktor Kualifikasi Usaha */
                  const mainKontraktorKualifikasiUsaha =
                      document.getElementById("mainKontraktorKualifikasiUsaha")
                  const DataOptionsmainKontraktorKualifikasiUsaha = {
                    labels: ["Kecil", "Sedang", "Besar"],
                    datasets: [
                      {
                        label: "Total Kontraktor",
                        data: [
                          this.mainKontraktorKecil,
                          this.mainKontraktorSedang,
                          this.mainKontraktorBesar,
                        ],
                        backgroundColor: ["rgb(246,133,133)", "rgb(243,86,86)","rgb(222,156,159)"],
                        hoverOffset: 6,
                      },
                    ],
                  }
                  const OptionsMainKontraktorKualifikasiUsaha = {
                    plugins: {
                      legend: {
                        position: "button",
                      },
                    },
                    cutoutPercentage: 80,
                  }
                  mainKontraktorKualifikasiUsaha
                      ? new Chart(mainKontraktorKualifikasiUsaha, {
                        type: "doughnut",
                        data: DataOptionsmainKontraktorKualifikasiUsaha,
                        options: OptionsMainKontraktorKualifikasiUsaha,
                      })
                      : console.log("Elemen Chart Kontraktor Kualifikasi Usaha tidak ditemukan")
                  /* End Chart Main Kontraktor Lokal dan Non-Lokal */

                  /* Chart Sub Kontraktor Inti dan Non-Inti */
                  const subIntiNonInti = document.getElementById("subKontraktorIntiNonInti")
                  const dataSubIntiNonInti = {
                    labels: ["Inti", "Non Inti"],
                    datasets: [
                      {
                        label: "Total Sub Kontraktor",
                        data: [
                          this.totalSubKontraktorInti,
                          this.totalSubKontraktorNonInti,
                        ],
                        backgroundColor: ["rgba(181, 26, 26, 1)", "rgba(255, 128, 128, 1)"],
                        hoverOffset: 10,
                      },
                    ]
                  }
                  const optionSubIntiNonInti = {
                    plugins: {
                      legend: {
                        position: "button"
                      }
                    },
                    cutoutPercentage: 100
                  }

                  subIntiNonInti
                      ? new Chart(subIntiNonInti, {
                        type: "doughnut",
                        data: dataSubIntiNonInti,
                        options: optionSubIntiNonInti,
                      })
                      : console.log("Elemen Chart Sub Kontraktor Inti Non Inti tidak ditemukan")

                  /* End Chart Sub Kontraktor Inti dan Non-Inti */

                  /* Chart Sub Kontraktor Lokal dan Non-Lokal */
                  const subKontraktorLokalNonLokal =
                      document.getElementById("subKontraktorLokalNonLokal")
                  const DataOptionsSubKontraktorLokalNonLokal = {
                    labels: ["Lokal", "Non Lokal"],
                    datasets: [
                      {
                        label: "Total Sub Kontraktor",
                        data: [
                          this.totalSubKontraktorLokals,
                          this.totalSubKontraktorNonLokal,
                        ],
                        backgroundColor: ["rgba(252, 204, 117, 1)", "rgba(255, 136, 0, 1)"],
                        hoverOffset: 6,
                      },
                    ],
                  }
                  const OptionsSubKontraktorLokalNonLokal = {
                    plugins: {
                      legend: {
                        position: "button",
                      },
                    },
                    cutoutPercentage: 80,
                  }
                  subKontraktorLokalNonLokal
                      ? new Chart(subKontraktorLokalNonLokal, {
                        type: "doughnut",
                        data: DataOptionsSubKontraktorLokalNonLokal,
                        options: OptionsSubKontraktorLokalNonLokal,
                      })
                      : console.log("Elemen Chart Sub Kontraktor Lokal Non Lokal tidak ditemukan")
                  /* End Chart Sub Kontraktor Lokal dan Non-Lokal */

                  /* Chart Sub Kontraktor Kualifikasi Usaha */
                  const subKontraktorKualifikasiUsaha =
                      document.getElementById("subKontraktorKualifikasiUsaha")
                  const DataOptionsSubKontraktorKualifikasiUsaha = {
                    labels: ["Besar", "Sedang", "Kecil"],
                    datasets: [
                      {
                        label: "Total Kontraktor",
                        data: [
                          this.totalSubKontraktorBesar,
                          this.totalSubKontraktorSedang,
                          this.totalSubKontraktorKecil,
                        ],
                        backgroundColor: ["rgb(222,156,159)", "rgb(246,133,133)", "rgb(243,86,86)"],
                        hoverOffset: 6,
                      },
                    ],
                  }
                  const OptionsSubKontraktorKualifikasiUsaha = {
                    plugins: {
                      legend: {
                        position: "button",
                      },
                    },
                    cutoutPercentage: 80,
                  }
                  subKontraktorKualifikasiUsaha
                      ? new Chart(subKontraktorKualifikasiUsaha, {
                        type: "doughnut",
                        data: DataOptionsSubKontraktorKualifikasiUsaha,
                        options: OptionsSubKontraktorKualifikasiUsaha,
                      })
                      : console.log("Elemen Chart Sub Kontraktor Kualifikasi Usaha tidak ditemukan")
                  /* End Chart Main Kontraktor Lokal dan Non-Lokal */

                })
                .catch((error) => {
                    console.error("Error fetching data:", error)
                })

        },

        ChartTotalSIO(){
            // let bodyJSONCreate = { role: "isafe", kontraktorId: null }
            // if (this.userData.kontraktorID != null) {
            //     bodyJSONCreate = {
            //         role: "kontraktor",
            //         kontraktorId: this.userData.kontraktorID,
            //     }
            // }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let config = {
                headers: {
                    role: role,
                    Authorization: `Bearer ${tokens.token}`,
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                },
            }
            axios
                .get(url_get_dashboard_sio,config)
                .then((response) => {
                  console.log('reseponse getDashboardSIO:',response)
                  // set value form edit
                  
                  this.dataDashboardSIO.totalPersyaratanAdministratif = response.data.totalPersyaratanAdministratif!==null?parseInt(response.data.totalPersyaratanAdministratif):0;
                  this.dataDashboardSIO.totalPembuatanJadwal = response.data.totalPembuatanJadwal!==null?parseInt(response.data.totalPembuatanJadwal):0;
                  this.dataDashboardSIO.totalPresentasi = response.data.totalPresentasi!==null?parseInt(response.data.totalPresentasi):0;
                  this.dataDashboardSIO.totalPemenuhanNc = response.data.totalPemenuhanNc!==null?parseInt(response.data.totalPemenuhanNc):0;
                  this.dataDashboardSIO.totalProsesSuratPengesahan = response.data.totalSuratPengesahan!==null?parseInt(response.data.totalProsesSuratPengesahan):0;
                  this.dataDashboardSIO.totalSuratPengesahan = response.data.totalSuratPengesahan!==null?parseInt(response.data.totalSuratPengesahan):0;
                  this.dataDashboardSIO.totalSioApproved = response.data.totalSioApproved!==null?parseInt(response.data.totalSioApproved):0;
                  this.dataDashboardSIO.totalPengajuan = parseInt(this.dataDashboardSIO.totalPersyaratanAdministratif+this.dataDashboardSIO.totalPembuatanJadwal+this.dataDashboardSIO.totalPresentasi+this.dataDashboardSIO.totalPemenuhanNc+this.dataDashboardSIO.totalProsesSuratPengesahan+this.dataDashboardSIO.totalSuratPengesahan+this.dataDashboardSIO.totalSioApproved);
                  
                  console.log('datachart:',[this.dataDashboardSIO.totalPersyaratanAdministratif, 
                        this.dataDashboardSIO.totalPembuatanJadwal, 
                        this.dataDashboardSIO.totalPresentasi, 
                        this.dataDashboardSIO.totalPemenuhanNc, 
                        this.dataDashboardSIO.totalSuratPengesahan, 
                        this.dataDashboardSIO.totalSioApproved])

                  const data = {
                labels: ['Persyaratan Administratif', 'Pembuatan Jadwal Presentasi', 'Presentasi Calon PJO', 'Pemenuhan NC Calon PJO', 'Surat Pengesahan PJO', 'CoC Approved'],
                datasets: [
                    {
                        label: 'Total CoC',
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        borderColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 1,
                        data: [this.dataDashboardSIO.totalPersyaratanAdministratif, 
                        this.dataDashboardSIO.totalPembuatanJadwal, 
                        this.dataDashboardSIO.totalPresentasi, 
                        this.dataDashboardSIO.totalPemenuhanNc, 
                        this.dataDashboardSIO.totalSuratPengesahan, 
                        this.dataDashboardSIO.totalSioApproved],
                    }
                ]
            };
            const totalValue = data.datasets[0].data.reduce((acc, curr) => acc + curr, 0);

            const TotalSIOPerStatus = document.getElementById("TotalSIOPerStatus")

           
            TotalSIOPerStatus
                      ? new Chart(TotalSIOPerStatus, {
                        type: 'bar',
                        data: data,
                        options: {
                            plugins: {
                                title: {
                                    display: false,
                                    text: 'Bar Chart with Total Value',
                                },
                                legend: {
                                    display: false,
                                },
                                annotation: {
                                    annotations: [
                                        {
                                            type: 'line',
                                            mode: 'horizontal',
                                            scaleID: 'y',
                                            value: totalValue,
                                            borderColor: 'rgb(75, 192, 192)',
                                            borderWidth: 2,
                                            label: {
                                                enabled: true,
                                                content: 'Total Pengajuan CoC: ' + totalValue,
                                                position: 'right',
                                            }
                                        }
                                    ]
                                },
                                tooltips: {
                                    enabled: false,
                                },
                            },
                            scales: {
                                xAxes: [{
                                    ticks: {
                                        fontSize: 8, // Adjust the font size of x-axis labels
                                    }
                                }],
                                yAxes: [{
                                    ticks: {
                                        callback: function(value) {
                                            return value;
                                        },
                                        fontSize: 8, // Adjust the font size of y-axis labels
                                    }
                                }]
                            },
                        },
                    })
                      : console.log("Elemen Chart Kontraktor Lokal Non Lokal tidak ditemukan")
                  
                })
                .catch((error) => {
                  alert("Error Fetch getDashboardSIO : " + error.message)
                  console.error("Error getDashboardSIO :", error)
                })

            // start draw chart
            this.$nextTick(function () {
              // DOM is now updated
              // `this` is bound to the current instance
            
            
            })
            
            // end draw chart
        },
        getSioID(){
          if(this.userData.kontraktorID != null){
            axios
                .get(url_get_sioid + this.userData.kontraktorID, { headers: {
                    role: this.userData.role,
                    Authorization: "Bearer " + this.userData.token,
                    // accept: "*/*",
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",} })
                .then((response) => {
                  if(response.data.data != null) {
                    this.dataSio = response.data.data
                    console.log("data sio nya = ", this.dataSio.status)
                  }
                })
                .catch((error) => {
                  this.isLoading = false;
                  alert("Error Fetch Data getSioID : " + error.message)
                  console.error("Error fetching data getSioID :", error.message)
                })
          }
        },
        totalImkp(){
          // let bodyJSONCreate = { role: "isafe", kontraktorId: null }
          // if (this.userData.kontraktorID != null) {
          //     bodyJSONCreate = {
          //         role: "kontraktor",
          //         kontraktorId: this.userData.kontraktorID,
          //     }
          // }
          const user = localStorage.getItem("user_cms")
          const tokens = JSON.parse(user)
          const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
          let config = {
            headers: {
              role: role,
              Authorization: `Bearer ${tokens.token}`,
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
              "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
            },
          }
          axios
              .get(url_get_dashboard_imkp,config)
              .then((response) => {
                console.log('reseponse getDashboardImkp:',response)
                // set value form edit

                this.dataDashboardImkp.totalImkpUnderReview = response.data.totalUnderReview!==null?parseInt(response.data.totalUnderReview):0;
                this.dataDashboardImkp.totalNeedRevision = response.data.totalNeedRevision!==null?parseInt(response.data.totalNeedRevision):0;
                this.dataDashboardImkp.totalDocumentComplete = response.data.totalDocumentComplete!==null?parseInt(response.data.totalDocumentComplete):0;
                this.dataDashboardImkp.totalProsesPenerbitanImkp = response.data.totalProsesPenerbitanImkp!==null?parseInt(response.data.totalProsesPenerbitanImkp):0;
                this.dataDashboardImkp.totalImkpPublished = response.data.totalImkpPublished!==null?parseInt(response.data.totalImkpPublished):0;
                this.dataDashboardImkp.totalProccessBast = response.data.totalProccessBast!==null?parseInt(response.data.totalProccessBast):0;
                this.dataDashboardImkp.totalBastDone = response.data.totalBastDone!==null?parseInt(response.data.totalBastDone):0;
                this.dataDashboardImkp.totalImkp = parseInt(this.dataDashboardImkp.totalImkpUnderReview+this.dataDashboardImkp.totalNeedRevision+this.dataDashboardImkp.totalDocumentComplete
                  + this.dataDashboardImkp.totalProsesPenerbitanImkp + this.dataDashboardImkp.totalImkpPublished+this.dataDashboardImkp.totalProccessBast+this.dataDashboardImkp.totalBastDone);

              })
              .catch((error) => {
                alert("Error Fetch getDashboardSIO : " + error.message)
                console.error("Error getDashboardSIO :", error)
              })

          // start draw chart
          this.$nextTick(function () {
            // DOM is now updated
            // `this` is bound to the current instance


          })

          // end draw chart
        },
        async getUserDetail(){
          try{
            const user_id = this.userData.userId;
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let params = {
              userId: user_id
            }
            const result = await axios.get(url_get_user_detail, {
              params: params,
              headers: {
                role: role,
                Authorization: `Bearer ${tokens.token}`,
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
              },
            });
            const res = result.data;
            if (!res.users.noHandphone || res.users.noHandphone?.trim() === "") {
              this.FormValuesEdit.userId = res.users.id;
              this.FormValuesEdit.email = res.users.email;
              this.FormValuesEdit.kontraktorId = res.users.kontraktorId;
              
              let button = document.createElement("a");
              button.setAttribute("id", "updateNoHandphone");
              button.setAttribute("data-bs-toggle", "modal");
              button.setAttribute("data-bs-target", "#update-no-handphone");
              document.body.appendChild(button);
              document.querySelector("#updateNoHandphone").click();
              button.remove();
            }
            
          }catch (e) {
            this.isLoading = false;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Terjadi kesalahan saat mencari detail User!",
            });
          }
        },
      async submitUpdateNoHandphone() {
        try {
          this.isNoHpValid = null;
          let bodyJson = {
            userId: this.FormValuesEdit.userId,
            email: this.FormValuesEdit.email,
            noHandphone: this.FormValuesEdit.noHandphone,
            kontraktorId: this.FormValuesEdit.kontraktorId,
            status: 1,
          }
          const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
          const user = localStorage.getItem("user_cms")
          const tokens = JSON.parse(user)

          axios.put(API_BASE_URL + CMS_GET_USER_UPDATE, bodyJson, {
            headers: {
              role: role,
              Authorization: `Bearer ${tokens.token}`,
              Accept: 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
              'Access-Control-Allow-Headers': 'Content-Type, Authorization, Accept'
            }
          }).then(() => {
            this.FormValuesEdit = {
              userId: "",
              email: "",
              kontraktorId: null,
              noHandphone: "",
            },

            document.getElementById("btnClose-update-no-handphone").click();

            Swal.fire({
              icon: 'success',
              title: 'Data berhasil diupdate!',
              showConfirmButton: false,
              timer: 1000
            })
          });
        } catch (e) {
          this.isLoading = false;
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan saat update data!",
          });
        }
      },
      validatePhoneEdit() {
        const phoneRegex = /^(?:62)[8][1-9][0-9]{6,11}$/; // Adjust pattern to fit rules
        if (this.FormValuesEdit.noHandphone.trim() === '') {
          this.isNoHpValid = null;
        } else {
          this.isNoHpValid = phoneRegex.test(this.FormValuesEdit.noHandphone);
        }
      }
    },
}
</script>
<style scoped>
/* main{
  font-family: "Inter-Thin", "sans-serif";
} */
section {
    font-family: "Inter", sans-serif;
    font-style: normal;
    min-height: 100vh;
}

.background {
    background-size: cover;
    background: linear-gradient(39.67deg, #000000 1.43%, rgba(0, 0, 0, 0) 74.24%),
        url("../../assets/images/tentang_bib.jpg") no-repeat;
    width: 100%;
    height: 289px;
}

.scrollable-container {
  height: 200px; /* Set a height for your container */
  overflow: auto; /* Make the container scrollable */
}

/* Important part */
/*.modal-dialog{
  overflow-y: initial !important
}
.modal-body{
  height: 50vh;
  overflow-y: auto;
}*/
</style>
